import {
    CLEAR_LISTINGS_ERRORS,
    CREATE_LISTINGS,
    DELETE_LISTINGS,
    DUPLICATE_LISTING,
    GET_LISTINGS_DETAILS,
    LISTINGS_LIST,
    LISTINGS_COUNT_RELATED_DATA,
    LISTINGS_SIMPLE_LIST,
    SHARE_LISTING,
    UPDATE_LISTINGS,
    UPDATE_LISTINGS_STATUS,
} from "@/core/services/store/listings.module";
import {GET_LEADS_BY_LISTING} from "@/core/services/store/leads.module";
import {mapState} from "vuex";
import {SET_CONFIRMATION} from "@/core/services/store/confirmation.module";
import {COMPLETIONSTATUSES_SIMPLE_LIST} from "@/core/services/store/completion_statuses.module";
import {bus} from "@/main";
import {hasMeaningfulUploadedFiles, hasMeaningfulUploadedLinks} from "@/core/services/store/uploads.module";
import {AMENITIES_SIMPLE_LIST} from "@/core/services/store/amenities.module";
import {VIEWS_SIMPLE_LIST} from "@/core/services/store/views.module";
import {PURPOSES_SIMPLE_LIST} from "@/core/services/store/purposes.module";
import {DEVELOPMENTTYPES_SIMPLE_LIST} from "@/core/services/store/developmenttypes.module";
import {PROJECTUNITTYPES_SIMPLE_LIST} from "@/core/services/store/projectunittypes.module";
import {PROJECTTYPICALFLOORPLANS_SIMPLE_LIST} from "@/core/services/store/projecttypicalfloorplans.module";
import {CONTACTS_SIMPLE_LIST} from "@/core/services/store/contacts.module";
import {SOURCES_SIMPLE_LIST} from "@/core/services/store/sources.module";
import {STAFF_LIST} from "@/core/services/store/users.module";
import ApiService from "@/core/services/api.service";
import Vue from "vue";
import {PUBLISHINGSTATUSES_SIMPLE_LIST} from "@/core/services/store/publishing_statuses.module";
// import ViewsSelection from "@/view/pages/realstate/selections/ViewsSelection";
// import LocationRemarksSelection from "@/view/pages/realstate/selections/LocationRemarksSelection";
// import AmenitiesSelection from "@/view/pages/realstate/selections/AmenitiesSelection";
// import RoadLocationsSelection from "@/view/pages/realstate/selections/RoadLocationsSelection";
import ModuleMedia from "@/view/pages/realstate/media/ModuleMedia";
import ModuleLinks from "@/view/pages/realstate/media/ModuleLinks";
import ModuleUploadedFiles from "@/view/pages/realstate/media/ModuleUploadedFiles";
import ListingFees from "@/view/pages/realstate/listings/inc/ListingFees";
import ListingFeatures from "@/view/pages/realstate/listings/inc/ListingFeatures";
import ListingDetails from "@/view/pages/realstate/listings/inc/ListingDetails";
import ListingOwnersHistory from "@/view/pages/realstate/listings/inc/ListingOwnersHistory";
import ListingOwnersTab from "@/view/pages/realstate/listings/inc/ListingOwnersTab";
import SharedListings from "@/view/pages/realstate/listings/inc/SharedListings";
import {FREQUENCIES_SIMPLE_LIST} from "@/core/services/store/frequencies.module";
import {GET_PROJECTUNITDETAILS_DETAILS_BY_UNIT_NUMBER} from "@/core/services/store/projectunitdetails.module";
import {ROADLOCATIONS_SIMPLE_LIST} from "@/core/services/store/road_locations.module";
import {LOCATIONREMARKS_SIMPLE_LIST} from "@/core/services/store/locationremarks.module";
import {PROJECTS_SIMPLE_LIST, GET_PROJECTS_DETAILS} from "@/core/services/store/projects.module";
import {
    DEVELOPMENTS_SIMPLE_LIST,
    DEVELOPMENTS_WITH_COUNT,
    DEVELOPMENTS_AND_PROJECTS_SIMPLE_LIST,
    DEVELOPMENTS_SIMPLE_BY_IDS_LIST
} from "@/core/services/store/developments.module";
import {VERIFY_AUTH} from "@/core/services/store/auth.module";
import {REMOVE_BODY_CLASSNAME} from "@/core/services/store/htmlclass.module";
import {SET_SNACK} from "@/core/services/store/snackbar.module";
import {SAVE_REPORT} from "@/core/services/store/dashboard.module";
import ReserveUnit from "@/view/pages/realstate/listings/inc/ReserveUnit.vue";
import ReleaseUnit from "@/view/pages/realstate/listings/inc/ReleaseUnit.vue";
import BookUnit from "@/view/pages/realstate/listings/inc/BookUnit.vue";
import ListingPaymentPlans from "@/view/pages/realstate/listings/inc/ListingPaymentPlans.vue";
import ActivityLogsPanel from "@/view/pages/realstate/logs/ActivityLogsPanel.vue";

const plotPropertyTypeKeywords = ['villa', 'townhouse', 'bungalow', 'stack house'];
const plotOrLandPropertyTypeKeywords = ['plot', 'land'];
const bedroomOptions = ['Studio'].concat(Array.from({length: 20}, (_, i) => String(i + 1)));
const bathroomOptions = Array.from({length: 20}, (_, i) => String(i + 1));

const listingsScript = {
    name: 'listings',
    components: {
        ListingPaymentPlans,
        BookUnit,
        ReleaseUnit,
        ReserveUnit,
        ModuleMedia,
        ModuleUploadedFiles,
        ListingFees,
        ListingDetails,
        ListingOwnersHistory,
        ListingOwnersTab,
        SharedListings,
        ListingFeatures,
        ModuleLinks,
        ActivityLogsPanel,
    },
    props: ['offerListings', 'modType', 'project', 'contact', 'listingId', 'matchingLeadId', 'offerListingsScope'],
    data() {
        return {
            mapInput: '',
            center: {},
            locationMarkers: [],
            existingPlace: null,
            headers: [
                {text: 'Title', value: 'title', name: 'title', filterable: true, sortable: false},
                {text: 'Country', value: 'country.title', name: 'country.title', filterable: false, sortable: false},
                {text: 'City', value: 'city.title', name: 'city.title', filterable: false, sortable: false},
                {text: "Created", value: "created_at", name: "created_at", filterable: false, sortable: true},
                {text: "Updated", value: "updated_at", name: "updated_at", filterable: false, sortable: false},
                {text: 'Actions', value: 'actions', name: 'actions', filterable: false, sortable: false},
            ],
            isLoaded: true,
            isLoadedContacts: false,
            draw: 1,
            searchQuery: "",
            loading: true,
            pagination: {
                page: 1,
                rowsPerPage: 25,
                totalItems: 0,
                sortDesc: "desc"
            },
            totalRecords: 0,
            rowsPerPageItems: [25, 50, 100, 150, 200],
            headerindex: "",
            projectTypesFilter: [],
            completionStatusesFilter: [],
            publishingStatusesFilter: [],
            iutFilter: [],
            eutFilter: [],
            tfpFilter: [],
            sourcesFilter: [],
            purposesFilter: [],
            ptFilter: [],
            projectsFilter: [],
            isProjectsLoaded: false,
            locationsFilter: [],
            isLocationsLoaded: false,
            filterLocationsFilter: [],
            isFilterLocationsLoaded: false,
            bedroomOptions,
            bathroomOptions,
            amenitiesFilter: [],
            amenitiesIdsFilter: [],
            viewsFilter: [],
            viewsIdsFilter: [],
            developersFilter: [],
            isDevelopersLoaded: false,
            coolingProvidersFilter: [],
            isCoolingProvidersLoaded: false,
            ownersFilter: [],
            isOwnersLoaded: false,
            kLFilter: [],
            isKLLoaded: false,
            keyLocationsSearch: null,
            ownersSearch: null,
            coolingProvidersSearch: null,
            developersSearch: null,
            listingLocationSearch: null,
            unitNumberFilter: [],
            isUnitNumberLoaded: false,
            tenantsFilter: [],
            isTenantsLoaded: false,
            staffFilter: [],
            rlFilter: [],
            rlIdsFilter: [],
            locationRemarksFilter: [],
            locationRemarksIdsFilter: [],
            rfFilter: [],
            strfFilter: [],
            columns: [],
            validationRules: {
                valid: true,
                titleRules: [
                    v => !!v || "This field is required",
                    v => (v && v.length >= 3) || "Must be greater than 3 characters",
                    v => (v && v.length <= 200) || "Must be less than 200 characters"
                ],
                unitNoRules: [
                    v => !!v || "This field is required",
                    v => (v && v.length >= 1) || "Must be greater than 1 characters",
                    v => (v && v.length <= 30) || "Must be less than 30 characters"
                ],
                selectRule: [
                    (v) => {
                        if (!v || v.length < 1)
                            return 'Select an option';
                        else return true;
                    }
                ],
                multipleRules: [
                    v => {
                        if (!v || v.length < 1) return "Select Master Developer";
                        else return true;
                    }
                ]
            },
            items: [],
            dialog: false,
            sumDialog: false,
            showUnitNo: 0,
            reportLink: '',
            editedItem: {
                add_on_broker_portal: 0,
                rent_agency_fee_tenant: '',
                rent_agency_fee_landlord: '',
                rent_security_fee: '',
                sale_paid_of_original_price: '',
                sale_agency_fee_buyer: '',
                sale_agency_fee_seller: '',
                sale_dld_fee: '',
                sale_transfer_fee_buyer: '',
                sale_transfer_fee_seller: '',
                sale_legal_fee: '',
                sale_original_price: '',
                sale_premium: '',
                sale_payable_now: '',
                sale_payable_now_developer: ''
            },
            showUploadedFiles: false,
            yscValue: '',
            yscMultiplyValue: '',
            mccValue: '',
            mccMultiplyValue: '',
            chargesMultiplies: [
                {value: "0", title: 'Built up area sq ft'},
                {value: "1", title: 'Plot area sq ft'},
            ],
            discountOnFilter: [
                {value: "Original Price", title: 'Original Price'},
                {value: "Paid Of Original Price", title: 'Paid Of Original Price'},
            ],
            masterPropertyType: '',
            locationRef: 'project',
            locationRefModel: '',
            builtUpAreaUnit: '',
            plotAreaUnit: '',
            warehouseOfficeSpaceUnit: '',
            warehouseOpenYardUnit: '',
            warehouseStorageAreaUnit: '',
            dupDialog: false,
            dupItem: '',
            duplicatedItem: {p_id: '', p_type_id: ''},
            listingsFilter: [],
            isListingsLoaded: false,
            searchFormData: {},
            developmentsFilter: [],
            isDevelopmentsLoaded: false,
            detailDialog: false,
            detailItem: {},
            advSHitted: false,
            shareDialog: false,
            matchLeadsDialog: false,
            matchLeadsLoading: false,
            matchLeadsItems: [],
            matchLeadsListingId: null,
            matchLeadsListingTitle: '',
            listingSharingIds: [],
            treeItems: [],
            locationSearchQuery: '',
            offerListingsSelection: [],
            matchingListingIds: [],
            offerAutoSelectedLeadId: null,
            offerDeselectedIds: [],
            resDialog: false,
            relDialog: false,
            bookDialog: false,
            resItem: {},
            reservationFormPdfLoadingId: null,
            spaFormPdfLoadingId: null,
            activityLogsDialog: false,
            activityLogsListingId: null,
            activityLogsTitle: '',
            ownersHistoryDialog: false,
            ownersHistoryLoading: false,
            ownersHistoryTitle: '',
            ownersHistoryItems: [],
            ownersHistoryRequestId: 0,
            listingOwners: [],
        }
    },
    watch: {
        // params: {
        //     handler() {
        //         this.loadData().then(response => {
        //             this.items = response.items;
        //             this.totalRecords = response.total;
        //         });
        //     },
        //     deep: true
        // },
        dupDialog(val) {
            if (!val) this.dupItem = '';
            if (!val) this.duplicatedItem = {p_id: '', p_type_id: ''}
        },
        project: {
            handler(v) {
                if (v.hasOwnProperty('title') || v.hasOwnProperty('commercial_title')) {
                    this.loadData().then(response => {
                        this.items = response.items;
                        this.totalRecords = response.total;
                    });
                }
            },
            deep: true
        },
        contact: {
            handler(v) {
                if (v.hasOwnProperty('full_name')) {
                    this.loadData().then(response => {
                        this.items = response.items;
                        this.totalRecords = response.total;
                    });
                }
            },
            deep: true
        },
        dialog(val) {
            if (!val && this.modType === 'contact') {
                this.finalizePendingActivityLog();
            }
            !val && this.$store.dispatch(CLEAR_LISTINGS_ERRORS);
            if (!val) this.$store.state.selections.selectedFolderId = ''
            if (!val) {
                let that = this;
                setTimeout(function () {
                    that.editedItem.description = '';
                }, 500)
            }
            if (!val) this.editedItem = {
                add_on_broker_portal: 0,
                rent_agency_fee_tenant: '',
                rent_agency_fee_landlord: '',
                rent_security_fee: '',
                sale_paid_of_original_price: '',
                sale_agency_fee_buyer: '',
                sale_agency_fee_seller: '',
                sale_dld_fee: '',
                sale_transfer_fee_buyer: '',
                sale_transfer_fee_seller: '',
                sale_legal_fee: '',
                sale_original_price: '',
                sale_premium: '',
                sale_payable_now: '',
                sale_payable_now_developer: ''
            };
            if (val) {
                this.applyDefaultDraftPublishingStatus();
                this.applyDefaultBrokerPortalFlag();
            }
            if (this.modType === 'project') {
                this.editedItem.project_id = this.project.id
            }
            if (!val) this.showUploadedFiles = false;
            if (!val) this.center = {lat: 0, lng: 0};
            if (!val) this.locationMarkers = [];
            if (!val) this.mapInput = '';
            if (!val) this.locationsFilter = [];
            if (!val) this.locationRefModel = '';
            if (!val) {
                this.iutFilter = [];
                this.eutFilter = [];
                this.tfpFilter = [];
                this.unitNumberFilter = [];
            }
            if (!val) this.$store.state.listings.latitude = '';
            if (!val) this.$store.state.listings.longitude = '';
            if (!val) this.$store.state.listings.yearlyServiceCharges = '';
            if (!val) this.$store.state.listings.monthlyCoolingCharges = '';
            if (!val) this.listingOwners = [];
            if (!val) this.activeTab = 0;
            if (!val) bus.$emit("moduleFilesDeletedByModal");
            if (!val) bus.$emit("moduleLinksDeletedByModal");
            if (!val) bus.$emit("listingFeesDeletedByModal");
            if (!val) bus.$emit("listingFeaturesDeletedByModal");
            if (val) {
                this.builtUpAreaUnit = this.builtUpAreaUnit ? this.builtUpAreaUnit : this.$store.state.auth.user.measurement_unit
                this.plotAreaUnit = this.plotAreaUnit ? this.plotAreaUnit : this.$store.state.auth.user.measurement_unit
                this.warehouseOfficeSpaceUnit = this.warehouseOfficeSpaceUnit ? this.warehouseOfficeSpaceUnit : this.$store.state.auth.user.measurement_unit
                this.warehouseOpenYardUnit = this.warehouseOpenYardUnit ? this.warehouseOpenYardUnit : this.$store.state.auth.user.measurement_unit
                this.warehouseStorageAreaUnit = this.warehouseStorageAreaUnit ? this.warehouseStorageAreaUnit : this.$store.state.auth.user.measurement_unit
            } else {
                this.builtUpAreaUnit = ''
                this.plotAreaUnit = ''
                this.warehouseOfficeSpaceUnit = ''
                this.warehouseOpenYardUnit = ''
                this.warehouseStorageAreaUnit = ''
            }
        },
        shareDialog(val) {
            if (val) {
                const index = this.staffFilter.findIndex(element => {
                    if (element.id === this.$store.state.auth.user.id) {
                        return true;
                    }
                });
                if (index !== -1) this.staffFilter.splice(index, 1);
            }
            if (!val) this.listingSharingIds = [];
        },
        offerListingsSelection(val) {
            const ids = (val || []).map(row => {
                if (row && typeof row === 'object') {
                    return Number(row.id);
                }
                return Number(row);
            }).filter(id => id > 0);
            // Remember ids the user unchecked so pagination does not re-select them.
            const selected = new Set(ids);
            (this.items || []).forEach(item => {
                const id = Number(item.id);
                if (id > 0 && !selected.has(id) && !(this.offerDeselectedIds || []).includes(id)) {
                    this.offerDeselectedIds = [...(this.offerDeselectedIds || []), id];
                }
            });
            this.$emit('offerListingsItem', ids);
        },
        offerListingsScope(val) {
            if (!this.isOfferListingsMode) {
                return;
            }
            this.applyOfferListingsScope(val || 'live');
            this.pagination.page = 1;
            this.refreshData(false);
        },
        matchingLeadId(val) {
            if (this.isOfferListingsMode && val) {
                this.offerAutoSelectedLeadId = null;
                this.offerDeselectedIds = [];
                this.offerListingsSelection = [];
                this.loadMatchingListingsForOffer(val);
            }
        },
        '$route'(to, from) {
            if (to.name === 'listings') {
                this.refreshData(false)
            }
        }
    },
    mounted() {
        for (var i = 0; i < this.headers.length; i++) {
            this.columns.push(
                '&columns[' + i + '][data]=' + this.headers[i].value +
                '&columns[' + i + '][name]=' + this.headers[i].name +
                '&columns[' + i + '][searchable]=' + this.headers[i].filterable +
                '&columns[' + i + '][orderable]=' + this.headers[i].sortable +
                '&columns[' + i + '][search][value]=' +
                '&columns[' + i + '][search][regex]=' + false
            );
        }
        this.searchFormData.showSearch = 0
        if (this.isOfferListingsMode) {
            this.applyOfferListingsScope(this.offerListingsScope || 'live');
            if (this.matchingLeadId) {
                this.$set(this.searchFormData, 'leadMatchId', this.matchingLeadId);
            }
        } else if (!this.modType) {
            this.applyDefaultLivePublishingFilter();
        }
        if (this.$route.query.hasOwnProperty('addModule')) {
            this.dialog = true;
        }
        if (this.$route.query.hasOwnProperty('rel')) {
            this.searchFormData.relId = parseInt(this.$route.query.rel);
        }
        if (this.$route.query.hasOwnProperty('listing')) {
            let listing = parseInt(this.$route.query.listing)
            let item = {id: listing}
            this.showEditDialog('detail', item)
        }
        // if (this.$route.query.hasOwnProperty('development')) {
        //     this.searchFormData.developmentSearch = parseInt(this.$route.query.development);
        // }
        if (!this.modType && this.$store.state.auth.user.type === 1) this.showTree(0, 'all');
        this.loadData().then(response => {
            this.items = response.items;
            this.totalRecords = response.total;
            this.applyMatchingOfferSelection(response.items);
            if (this.$store.state.auth.user.type === 1) {
                this.getPurposes();
            } else {
                this.getPropertyTypes(false);
            }
        });
    },
    methods: {
        applyOfferListingsScope(scope) {
            if (scope === 'all') {
                this.$set(this.searchFormData, 'psSearch', '');
            } else {
                // Live publishing status
                this.$set(this.searchFormData, 'psSearch', this.resolveLivePublishingStatusId());
            }
        },
        resolveLivePublishingStatusId() {
            const list = this.publishingStatusesFilter || [];
            const live = list.find((status) => String(status.title || '').trim().toLowerCase() === 'live');
            return live && live.id ? live.id : 1;
        },
        resolveDraftPublishingStatusId() {
            const list = this.publishingStatusesFilter || [];
            const draft = list.find((status) => String(status.title || '').trim().toLowerCase() === 'draft');
            return draft && draft.id ? draft.id : 4;
        },
        applyDefaultDraftPublishingStatus() {
            if (this.editedItem && this.editedItem.id) {
                return;
            }
            if (this.editedItem && this.editedItem.publishing_status_id) {
                return;
            }
            this.$set(this.editedItem, 'publishing_status_id', this.resolveDraftPublishingStatusId());
        },
        applyDefaultBrokerPortalFlag() {
            if (this.editedItem && this.editedItem.id) {
                return;
            }
            if (this.editedItem && this.editedItem.add_on_broker_portal !== undefined && this.editedItem.add_on_broker_portal !== null) {
                return;
            }
            this.$set(this.editedItem, 'add_on_broker_portal', 0);
        },
        applyDefaultLivePublishingFilter() {
            this.$set(this.searchFormData, 'psSearch', this.resolveLivePublishingStatusId());
        },
        loadMatchingListingsForOffer(leadId) {
            if (!leadId) {
                this.$delete(this.searchFormData, 'leadMatchId');
                this.refreshData(true);
                return;
            }
            this.$set(this.searchFormData, 'leadMatchId', leadId);
            this.pagination.page = 1;
            this.refreshData(true);
        },
        applyMatchingOfferSelection(items) {
            if (!this.isOfferListingsMode || !items || !items.length) {
                return;
            }
            const deselected = new Set((this.offerDeselectedIds || []).map(id => Number(id)));
            const selected = new Set((this.offerListingsSelection || []).map(id => Number(id)));
            let changed = false;
            items.forEach(item => {
                const id = Number(item.id);
                if (id > 0 && !deselected.has(id) && !selected.has(id)) {
                    selected.add(id);
                    changed = true;
                }
            });
            if (changed || this.offerAutoSelectedLeadId !== this.matchingLeadId) {
                this.offerAutoSelectedLeadId = this.matchingLeadId;
                this.offerListingsSelection = Array.from(selected);
            }
        },
        customFilter(item, queryText, itemText) {
            if (item.header || item.divider) {
                return true;
            }
            const searchText = queryText.toLowerCase();
            const itemTitle = item.text.toLowerCase();
            return itemTitle.includes(searchText);
        },
        initMarker(loc) {
            this.existingPlace = loc;
        },
        addLocationMarker() {
            if (this.existingPlace) {
                this.locationMarkers = [];
                const marker = {
                    lat: this.existingPlace.geometry.location.lat(),
                    lng: this.existingPlace.geometry.location.lng()
                };
                this.$store.state.listings.latitude = this.existingPlace.geometry.location.lat();
                this.$store.state.listings.longitude = this.existingPlace.geometry.location.lng();
                this.editedItem.location = this.existingPlace.formatted_address;
                this.mapInput = '';
                // this.editedItem.latitude = this.existingPlace.geometry.location.lat();
                // this.editedItem.longitude = this.existingPlace.geometry.location.lng();
                this.locationMarkers.push({position: marker});
                this.center = marker;
                this.existingPlace = null;
            }
        },
        setLatLong(e) {
            this.existingPlace = null;
            this.mapInput = '';
            let latLng = e.latLng.toJSON()
            this.$store.state.listings.latitude = latLng.lat;
            this.$store.state.listings.longitude = latLng.lng;
            const marker = {
                lat: latLng.lat,
                lng: latLng.lng
            };
            this.locationMarkers = [{position: marker}];
            this.center = marker;
        },
        getHeaderIndex(name) {
            let that = this;
            this.headers.filter(function (ele, i) {
                if (name == ele.name) {
                    that.headerindex = i;
                }
            });
        },
        /**
         * Prefer API filtered total; never show 0 while the page clearly has rows
         * (deferred count may arrive as 0/pending before the related-data call).
         */
        resolveListingsTotal(items, total, pending = false) {
            if (!items || !items.length) {
                return 0;
            }
            const n = Number(total);
            if (Number.isFinite(n) && n > 0) {
                return n;
            }
            if (pending || total === null || total === undefined || total === '' || n === 0) {
                return items.length;
            }
            return items.length;
        },
        loadData() {
            this.loading = true;
            this.isLoaded = true;
            this.items = [];
            this.totalRecords = 0;
            this.mainDataTableSelection = [];
            this.loadRequestId = (this.loadRequestId || 0) + 1;
            const requestId = this.loadRequestId;
            if (this.listingId) {
                this.searchFormData.idSearch = this.listingId
            } else {
                this.searchFormData.idSearch = ''
            }
            if (this.modType === 'project') this.searchFormData.projectSearch = this.project.id
            if (this.modType === 'development') this.searchFormData.developmentSearch = this.project.id
            if (this.modType === 'contact') {
                this.searchFormData.contactSearch = this.contact.id
                this.searchFormData.listings_view_source = 'contact_properties'
            }
            if (!this.modType) {
                this.searchFormData.isListing = 1
            }
            return new Promise((resolve) => {
                let params = this.params;
                params.length = params.itemsPerPage; //set how many records to fetch per page
                params.start =
                    params.page == 1 ? 0 : params.itemsPerPage * (params.page - 1); //set offset
                params.draw = this.draw;
                let query = Object.keys(params).map((key) => {
                    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
                }).join('&');
                let searchFormDataQuery = Object.keys(this.searchFormData).map((key) => {
                    const value = this.searchFormData[key];
                    if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
                        return null;
                    }
                    return encodeURIComponent(key) + '=' + encodeURIComponent(value)
                }).filter(Boolean).join('&');
                this.getHeaderIndex(params.sortBy[0]);
                query += '&' + searchFormDataQuery
                query +=
                    "&search[value]=" +
                    params.query +
                    "&search[regex]=" +
                    false +
                    "&order[0][column]=" +
                    (params.sortBy.length === 0 ? 3 : this.headerindex) +
                    "&order[0][dir]=" +
                    (params.sortDesc[0] ? "desc" : "asc");
                this.$store.dispatch(LISTINGS_LIST, {q: query + '&defer_related_data=1', columns: this.columns}).then((res) => {
                    if (requestId !== this.loadRequestId) {
                        return;
                    }
                    let items = (res.records && res.records.data) ? res.records.data : [];
                    let pending = !!(res.records && res.records.filtered_count_pending);
                    let total = this.resolveListingsTotal(items, res.records ? res.records.recordsFiltered : null, pending);
                    this.items = items;
                    this.totalRecords = total;
                    this.loading = false;
                    this.isLoaded = false;
                    resolve({
                        items,
                        total: this.totalRecords
                    });
                    this.loadListingsRelatedData(items, searchFormDataQuery, requestId);
                }).catch(() => {
                    if (requestId !== this.loadRequestId) {
                        return;
                    }
                    this.loading = false;
                    this.isLoaded = false;
                    resolve({
                        items: this.items,
                        total: this.totalRecords
                    });
                });
            });
        },
        loadListingsRelatedData(items, searchFormDataQuery, requestId = null) {
            if (this.$store.state.auth.user.type !== 1) return;
            let ids = (items || [])
                .map(item => (item ? item.id : null))
                .filter(id => id !== null && id !== undefined && id !== '');
            let relatedQuery = 'ids=' + encodeURIComponent(ids.join(',')) + '&' + searchFormDataQuery;
            this.$store.dispatch(LISTINGS_COUNT_RELATED_DATA, {q: relatedQuery}).then((res) => {
                if (requestId !== null && requestId !== this.loadRequestId) {
                    return;
                }
                if (res.records && res.records.filtered_count !== null && res.records.filtered_count !== undefined) {
                    const rowItems = (this.items && this.items.length) ? this.items : items;
                    this.totalRecords = this.resolveListingsTotal(
                        rowItems,
                        res.records.filtered_count,
                        !!(res.records.filtered_count_pending)
                    );
                }
                if (!ids.length || !res || !res.records || !res.records.data) return;
                if (!this.items || !this.items.length) return;
                let byId = {};
                res.records.data.forEach(row => {
                    byId[row.id] = row;
                });
                this.items.forEach(item => {
                    let data = byId[item.id];
                    if (!data) return;
                    const fields = [
                        'view_o_and_u',
                        'latest_reserve',
                        'latest_book',
                        'reserve_sale_price',
                        'reservation_price',
                        'reserved_by',
                        'booked_by',
                        'developer_pdf_assets_ready',
                        'owners',
                        'payment_plans',
                        'reserved_user',
                        'released_user',
                        'booked_user',
                        'developer',
                    ];
                    fields.forEach(field => {
                        if (Object.prototype.hasOwnProperty.call(data, field)) {
                            this.$set(item, field, data[field]);
                        }
                    });
                    if (data.project) {
                        this.$set(item, 'project', Object.assign({}, item.project || {}, data.project));
                    }
                });
            });
        },
        refreshData(loadDep = true) {
            this.loadData().then(response => {
                this.items = response.items;
                this.totalRecords = response.total ?? response.items.length;
                this.applyMatchingOfferSelection(response.items);
                this.advSHitted = !this.advSHitted
                if (loadDep) {
                    if (this.$store.state.auth.user.type === 1) {
                        this.getPurposes();
                    } else if (!this.ptFilter.length) {
                        this.getPropertyTypes(false);
                    }
                }
            });
        },
        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },
        hitAdvanceSearch(reset = false) {
            this.pagination.page = 1
            if (reset) {
                const preserved = {};
                if (this.modType === 'project' && this.project && this.project.id) {
                    preserved.projectSearch = this.project.id;
                }
                if (this.modType === 'development' && this.project && this.project.id) {
                    preserved.developmentSearch = this.project.id;
                }
                if (this.modType === 'contact' && this.contact && this.contact.id) {
                    preserved.contactSearch = this.contact.id;
                    preserved.listings_view_source = 'contact_properties';
                }
                if (this.isOfferListingsMode) {
                    preserved.leadMatchId = this.searchFormData.leadMatchId || this.matchingLeadId;
                    preserved.psSearch = this.searchFormData.psSearch;
                } else if (!this.modType) {
                    preserved.psSearch = this.resolveLivePublishingStatusId();
                }
                this.searchFormData = preserved;
                if (!this.modType) {
                    this.showTree(0, 'all');
                    this.searchFormData.showSearch = 0;
                }
            }
            this.advSHitted = !this.advSHitted;
            this.loadData().then(response => {
                this.items = response.items;
                this.totalRecords = response.total;
                this.applyMatchingOfferSelection(response.items);
            });
        },
        showEditDialog(type, item) {
            this.$store.dispatch(GET_LISTINGS_DETAILS, item.id).then((data) => {
                if (type === 'edit') {
                    this.editedItem = data.records || {
                        add_on_broker_portal: 0,
                        rent_agency_fee_tenant: '',
                        rent_agency_fee_landlord: '',
                        rent_security_fee: '',
                        sale_paid_of_original_price: '',
                        sale_agency_fee_buyer: '',
                        sale_agency_fee_seller: '',
                        sale_dld_fee: '',
                        sale_transfer_fee_buyer: '',
                        sale_transfer_fee_seller: '',
                        sale_legal_fee: '',
                        sale_original_price: '',
                        sale_premium: '',
                        sale_payable_now: '',
                        sale_payable_now_developer: ''
                    };
                    if (this.editedItem.add_on_broker_portal === undefined || this.editedItem.add_on_broker_portal === null) {
                        this.$set(this.editedItem, 'add_on_broker_portal', 0);
                    } else {
                        this.$set(this.editedItem, 'add_on_broker_portal', Number(this.editedItem.add_on_broker_portal) === 1 ? 1 : 0);
                    }
                    this.mapInput = '';
                    this.builtUpAreaUnit = data.records.built_up_area_unit
                    this.plotAreaUnit = data.records.plot_area_unit
                    this.warehouseOfficeSpaceUnit = data.records.warehouse_office_space_unit
                    this.warehouseOpenYardUnit = data.records.warehouse_open_yard_unit
                    this.warehouseStorageAreaUnit = data.records.warehouse_storage_area_unit
                    this.$store.state.listings.latitude = data.records.latitude ? parseFloat(data.records.latitude) : 0;
                    this.$store.state.listings.longitude = data.records.longitude ? parseFloat(data.records.longitude) : 0;
                    if (this.editedItem.max_sale_price > 500000) {
                        this.editedItem.sale_trustee_office_fee = "4,200"
                    }
                    if (this.editedItem.max_sale_price < 500000) {
                        this.editedItem.sale_trustee_office_fee = "2,200"
                    }
                    if (!this.editedItem.sale_dev_noc_fee && this.editedItem.completion_status_id === 7) {
                        this.editedItem.sale_dev_noc_fee = "500"
                    }
                    if (!this.editedItem.sale_dev_noc_fee && this.editedItem.completion_status_id && this.editedItem.completion_status_id !== 7) {
                        this.editedItem.sale_dev_noc_fee = "5,000"
                    }
                    const marker = {
                        lat: data.records.latitude ? parseFloat(data.records.latitude) : 0,
                        lng: data.records.longitude ? parseFloat(data.records.longitude) : 0
                    };
                    this.locationMarkers.push({position: marker});
                    this.center = marker;
                    if (data.records.project) {
                        this.locationRefModel = 'project';
                        this.projectsFilter = [data.records.project];
                        this.locationsFilter = [this.mapListingLocationItem({
                            id: data.records.project.id,
                            title: data.records.project.title,
                            text: data.records.project.title
                        }, 'project')];
                        this.$set(this.editedItem, 'location_uid', this.locationsFilter[0].uid);
                        this.getInternalUnitTypes(data.records.project_id);
                        this.loadProjectUnitNumbers(data.records.project_id);
                    }
                    if (data.records.development) {
                        this.locationRefModel = 'development';
                        this.projectsFilter = [data.records.development];
                        this.locationsFilter = [this.mapListingLocationItem({
                            id: data.records.development.id,
                            title: data.records.development.commercial_title || data.records.development.title,
                            commercial_title: data.records.development.commercial_title,
                            text: data.records.development.commercial_title || data.records.development.title,
                            type: data.records.development.type
                        }, 'development')];
                        this.$set(this.editedItem, 'location_uid', this.locationsFilter[0].uid);
                    }
                    if (data.records.developer) {
                        this.developersFilter = [data.records.developer];
                    }
                    if (data.records.tenant) {
                        this.tenantsFilter = [data.records.tenant];
                    }
                    this.$store.state.listings.yearlyServiceCharges = this.addTSBV(data.records.yearly_service_charges)
                    this.$store.state.listings.monthlyCoolingCharges = this.addTSBV(data.records.monthly_cooling_charges)
                    this.editedItem.min_rent_per_annum = this.addTSBV(data.records.min_rent_per_annum)
                    this.editedItem.max_rent_per_annum = this.addTSBV(data.records.max_rent_per_annum)
                    this.editedItem.rent_agency_fee_tenant = this.addTSBV(data.records.rent_agency_fee_tenant)
                    this.editedItem.rent_agency_fee_landlord = this.addTSBV(data.records.rent_agency_fee_landlord)
                    this.editedItem.rent_security_fee = this.addTSBV(data.records.rent_security_fee)
                    this.editedItem.total_rent = this.addTSBV(data.records.total_rent)
                    this.editedItem.min_sale_price = this.addTSBV(data.records.min_sale_price)
                    this.editedItem.max_sale_price = this.addTSBV(data.records.max_sale_price)
                    this.editedItem.sale_original_price = this.addTSBV(data.records.sale_original_price)
                    this.editedItem.sale_paid_of_original_price = this.addTSBV(data.records.sale_paid_of_original_price)
                    this.editedItem.sale_discount = this.addTSBV(data.records.sale_discount)
                    this.editedItem.sale_premium = this.addTSBV(data.records.sale_premium)
                    this.editedItem.sale_agency_fee_buyer = this.addTSBV(data.records.sale_agency_fee_buyer)
                    this.editedItem.sale_agency_fee_seller = this.addTSBV(data.records.sale_agency_fee_seller)
                    this.editedItem.sale_dld_fee = this.addTSBV(data.records.sale_dld_fee)
                    this.editedItem.sale_transfer_fee_buyer = this.addTSBV(data.records.sale_transfer_fee_buyer)
                    this.editedItem.sale_transfer_fee_seller = this.addTSBV(data.records.sale_transfer_fee_seller)
                    this.editedItem.sale_dev_noc_fee = this.addTSBV(data.records.sale_dev_noc_fee)
                    this.editedItem.sale_trustee_office_fee = this.addTSBV(data.records.sale_trustee_office_fee)
                    this.editedItem.sale_legal_fee = this.addTSBV(data.records.sale_legal_fee)
                    this.editedItem.sale_payable_now = this.addTSBV(data.records.sale_payable_now)
                    this.editedItem.sale_payable_now_developer = this.addTSBV(data.records.sale_payable_now_developer)
                    this.editedItem.tenancy_rent = this.addTSBV(data.records.tenancy_rent)
                    this.ownersFilter = data.records.owners;
                    this.listingOwners = this.mapOwnerHistoryToManagedOwners(data.records.owner_history);
                    this.kLFilter = data.records.key_locations;
                    this.coolingProvidersFilter = data.records.cooling_providers;
                    this.editedItem.description = data.records.description ? data.records.description : '';
                    // this.$store.state.selections.selectedViewIds = this.editedItem.view_ids
                    // this.$store.state.selections.selectedLRIds = this.editedItem.location_remark_ids
                    // this.$store.state.selections.selectedAmenityIds = this.editedItem.amenity_ids
                    // this.$store.state.selections.selectedRLIds = this.editedItem.road_location_ids
                    if (this.editedItem.purpose_id === 2) {
                        this.getAmountByPercentageWe("5", this.editedItem.max_rent_per_annum, 'rent_agency_fee_tenant')
                        this.editedItem.rent_agency_fee_tenant_percentage = "5"
                    } else {
                        this.getAmountByPercentageWe("2", this.editedItem.max_sale_price, 'sale_agency_fee_buyer')
                        this.getAmountByPercentageWe("2", this.editedItem.max_sale_price, 'sale_agency_fee_seller')
                        this.getAmountByPercentageWe("4", this.editedItem.max_sale_price, 'sale_transfer_fee_buyer')
                        this.editedItem.sale_agency_fee_buyer_percentage = "2"
                        this.editedItem.sale_agency_fee_seller_percentage = "2"
                        this.editedItem.sale_transfer_fee_buyer_percentage = "4"
                    }
                    this.dialog = true;
                    this.showUploadedFiles = true;
                } else if (type === 'price') {
                    this.editedItem = data.records || {
                        rent_agency_fee_tenant: '',
                        rent_agency_fee_landlord: '',
                        rent_security_fee: '',
                        sale_paid_of_original_price: '',
                        sale_agency_fee_buyer: '',
                        sale_agency_fee_seller: '',
                        sale_dld_fee: '',
                        sale_transfer_fee_buyer: '',
                        sale_transfer_fee_seller: '',
                        sale_legal_fee: '',
                        sale_original_price: '',
                        sale_premium: '',
                        sale_payable_now: '',
                        sale_payable_now_developer: ''
                    };
                    if (this.editedItem.max_sale_price > 500000) {
                        this.editedItem.sale_trustee_office_fee = "4,200"
                    }
                    if (this.editedItem.max_sale_price < 500000) {
                        this.editedItem.sale_trustee_office_fee = "2,200"
                    }
                    if (!this.editedItem.sale_dev_noc_fee && this.editedItem.completion_status_id === 7) {
                        this.editedItem.sale_dev_noc_fee = "500"
                    }
                    if (!this.editedItem.sale_dev_noc_fee && this.editedItem.completion_status_id && this.editedItem.completion_status_id !== 7) {
                        this.editedItem.sale_dev_noc_fee = "5,000"
                    }
                    this.editedItem.min_rent_per_annum = this.addTSBV(data.records.min_rent_per_annum)
                    this.editedItem.max_rent_per_annum = this.addTSBV(data.records.max_rent_per_annum)
                    this.editedItem.rent_agency_fee_tenant = this.addTSBV(data.records.rent_agency_fee_tenant)
                    this.editedItem.rent_agency_fee_landlord = this.addTSBV(data.records.rent_agency_fee_landlord)
                    this.editedItem.rent_security_fee = this.addTSBV(data.records.rent_security_fee)
                    this.editedItem.total_rent = this.addTSBV(data.records.total_rent)
                    this.editedItem.min_sale_price = this.addTSBV(data.records.min_sale_price)
                    this.editedItem.max_sale_price = this.addTSBV(data.records.max_sale_price)
                    this.editedItem.sale_original_price = this.addTSBV(data.records.sale_original_price)
                    this.editedItem.sale_paid_of_original_price = this.addTSBV(data.records.sale_paid_of_original_price)
                    this.editedItem.sale_discount = this.addTSBV(data.records.sale_discount)
                    this.editedItem.sale_premium = this.addTSBV(data.records.sale_premium)
                    this.editedItem.sale_agency_fee_buyer = this.addTSBV(data.records.sale_agency_fee_buyer)
                    this.editedItem.sale_agency_fee_seller = this.addTSBV(data.records.sale_agency_fee_seller)
                    this.editedItem.sale_dld_fee = this.addTSBV(data.records.sale_dld_fee)
                    this.editedItem.sale_transfer_fee_buyer = this.addTSBV(data.records.sale_transfer_fee_buyer)
                    this.editedItem.sale_transfer_fee_seller = this.addTSBV(data.records.sale_transfer_fee_seller)
                    this.editedItem.sale_dev_noc_fee = this.addTSBV(data.records.sale_dev_noc_fee)
                    this.editedItem.sale_trustee_office_fee = this.addTSBV(data.records.sale_trustee_office_fee)
                    this.editedItem.sale_legal_fee = this.addTSBV(data.records.sale_legal_fee)
                    this.editedItem.sale_payable_now = this.addTSBV(data.records.sale_payable_now)
                    this.editedItem.sale_payable_now_developer = this.addTSBV(data.records.sale_payable_now_developer)
                    this.editedItem.tenancy_rent = this.addTSBV(data.records.tenancy_rent)
                    this.ownersFilter = data.records.owners;
                    this.kLFilter = data.records.key_locations;
                    this.coolingProvidersFilter = data.records.cooling_providers;
                    this.editedItem.description = data.records.description ? data.records.description : '';
                    this.$store.state.selections.selectedViewIds = this.editedItem.view_ids
                    this.$store.state.selections.selectedLRIds = this.editedItem.location_remark_ids
                    this.$store.state.selections.selectedAmenityIds = this.editedItem.amenity_ids
                    this.$store.state.selections.selectedRLIds = this.editedItem.road_location_ids
                    // if (this.editedItem.purpose_id === 2) {
                    //     this.getAmountByPercentageWe("5", this.editedItem.max_rent_per_annum, 'rent_agency_fee_tenant')
                    //     this.editedItem.rent_agency_fee_tenant_percentage = "5"
                    // } else {
                    //     this.getAmountByPercentageWe("2", this.editedItem.max_sale_price, 'sale_agency_fee_buyer')
                    //     this.getAmountByPercentageWe("2", this.editedItem.max_sale_price, 'sale_agency_fee_seller')
                    //     this.getAmountByPercentageWe("4", this.editedItem.max_sale_price, 'sale_transfer_fee_buyer')
                    //     this.editedItem.sale_agency_fee_buyer_percentage = "2"
                    //     this.editedItem.sale_agency_fee_seller_percentage = "2"
                    //     this.editedItem.sale_transfer_fee_buyer_percentage = "4"
                    // }
                    let domain = '';
                    if (this.$store.state.auth.user.team_id === 1) {
                        domain = 'dubricks.com'
                    }
                    if (this.$store.state.auth.user.team_id === 2) {
                        domain = 'afsrealestate.com'
                    }
                    let url = 'https://' + domain + '/listing-price-report?ref=' + this.editedItem.id + '&tkn=15s4d1e51fs48ert4g1g5gh4f'
                    this.generateReport(url)
                } else {
                    this.detailItem = data.records || {};
                    this.$store.state.listings.yearlyServiceCharges = this.addTSBV(data.records.yearly_service_charges)
                    this.$store.state.listings.monthlyCoolingCharges = this.addTSBV(data.records.monthly_cooling_charges)
                    this.detailItem.min_rent_per_annum = this.addTSBV(data.records.min_rent_per_annum)
                    this.detailItem.max_rent_per_annum = this.addTSBV(data.records.max_rent_per_annum)
                    this.detailItem.rent_agency_fee_tenant = this.addTSBV(data.records.rent_agency_fee_tenant)
                    this.detailItem.rent_agency_fee_landlord = this.addTSBV(data.records.rent_agency_fee_landlord)
                    this.detailItem.rent_security_fee = this.addTSBV(data.records.rent_security_fee)
                    this.detailItem.total_rent = this.addTSBV(data.records.total_rent)
                    this.detailItem.min_sale_price = this.addTSBV(data.records.min_sale_price)
                    this.detailItem.max_sale_price = this.addTSBV(data.records.max_sale_price)
                    this.detailItem.sale_original_price = this.addTSBV(data.records.sale_original_price)
                    this.detailItem.sale_paid_of_original_price = this.addTSBV(data.records.sale_paid_of_original_price)
                    this.detailItem.sale_discount = this.addTSBV(data.records.sale_discount)
                    this.detailItem.sale_premium = this.addTSBV(data.records.sale_premium)
                    this.detailItem.sale_agency_fee_buyer = this.addTSBV(data.records.sale_agency_fee_buyer)
                    this.detailItem.sale_agency_fee_seller = this.addTSBV(data.records.sale_agency_fee_seller)
                    this.detailItem.sale_dld_fee = this.addTSBV(data.records.sale_dld_fee)
                    this.detailItem.sale_transfer_fee_buyer = this.addTSBV(data.records.sale_transfer_fee_buyer)
                    this.detailItem.sale_transfer_fee_seller = this.addTSBV(data.records.sale_transfer_fee_seller)
                    this.detailItem.sale_legal_fee = this.addTSBV(data.records.sale_legal_fee)
                    this.detailItem.sale_trustee_office_fee = this.addTSBV(data.records.sale_trustee_office_fee)
                    this.detailItem.sale_dev_noc_fee = this.addTSBV(data.records.sale_dev_noc_fee)
                    this.detailItem.sale_payable_now = this.addTSBV(data.records.sale_payable_now)
                    this.detailItem.sale_payable_now_developer = this.addTSBV(data.records.sale_payable_now_developer)
                    this.detailItem.tenancy_rent = this.addTSBV(data.records.tenancy_rent)
                    this.detailItem.description = data.records.description ? data.records.description : '';
                    this.detailDialog = !this.detailDialog;
                }
            });
        },
        closeDialog() {
            this.dialog = !this.dialog;
        },
        rrbUnits(type, item) {
            if (type === 'reserve') {
                if (this.isListingAlreadyReserved(item)) {
                    return;
                }

                if (item.booked_user || item.booked_by) {
                    this.$store.dispatch(SET_SNACK, { clr: 'error', msg: this.getListingBookedStatusMessage(item) });
                    return;
                }

                this.resItem = { ...item };
                this.resDialog = true;

                this.$store.dispatch(GET_LISTINGS_DETAILS, item.id).then((data) => {
                    const detail = data && data.records ? data.records : {};
                    if (this.isListingAlreadyReserved(detail)) {
                        this.resDialog = false;
                        this.resItem = {};
                        return;
                    }
                    if (detail.booked_by) {
                        this.resDialog = false;
                        this.resItem = {};
                        this.$store.dispatch(SET_SNACK, { clr: 'error', msg: this.getListingBookedStatusMessage(detail) });
                        return;
                    }
                    this.resItem = this.buildReserveDialogItem(item, detail);
                });

                return;
            }

            if (type === 'release') {
                this.resItem = { ...item };
                this.relDialog = true;

                this.$store.dispatch(GET_LISTINGS_DETAILS, item.id).then((data) => {
                    const detail = data && data.records ? data.records : {};
                    this.resItem = this.buildReserveDialogItem(item, detail);
                });

                return;
            }

            if (type === 'book') {
                this.resItem = { ...item };
                this.bookDialog = true;

                this.$store.dispatch(GET_LISTINGS_DETAILS, item.id).then((data) => {
                    const detail = data && data.records ? data.records : {};
                    this.resItem = this.buildReserveDialogItem(item, detail);
                });

                return;
            }
        },
        isReservationFormPdfLoading(item) {
            if (!item || !item.id) {
                return false;
            }

            return Number(this.reservationFormPdfLoadingId) === Number(item.id);
        },
        isSpaFormPdfLoading(item) {
            if (!item || !item.id) {
                return false;
            }

            return Number(this.spaFormPdfLoadingId) === Number(item.id);
        },
        openReservationFormPdf(item) {
            if (!item || !item.id || this.isReservationFormPdfLoading(item)) {
                return;
            }

            ApiService.setHeader();
            this.$set(this, 'reservationFormPdfLoadingId', Number(item.id));

            Vue.axios
                .get(`api/listingreservationformpdf/${item.id}/share`)
                .then((response) => {
                    const data = response.data || {};
                    if (!data._metadata || data._metadata.outcomeCode !== 0) {
                        const message = data._metadata && data._metadata.message
                            ? data._metadata.message
                            : 'Unable to generate reservation form PDF.';
                        this.$store.dispatch(SET_SNACK, { clr: 'error', msg: message });
                        return;
                    }

                    const token = data.records && data.records.token;
                    if (!token) {
                        this.$store.dispatch(SET_SNACK, { clr: 'error', msg: 'Unable to generate reservation form PDF.' });
                        return;
                    }

                    const url = `${window.location.origin}/reservation-form/${token}`;
                    window.open(url, '_blank');
                })
                .catch(() => {
                    this.$store.dispatch(SET_SNACK, { clr: 'error', msg: 'Unable to generate reservation form PDF.' });
                })
                .finally(() => {
                    this.$set(this, 'reservationFormPdfLoadingId', null);
                });
        },
        openSpaFormPdf(item) {
            if (!item || !item.id || this.isSpaFormPdfLoading(item)) {
                return;
            }

            ApiService.setHeader();
            this.$set(this, 'spaFormPdfLoadingId', Number(item.id));

            Vue.axios
                .get(`api/listingspaformpdf/${item.id}/share`)
                .then((response) => {
                    const data = response.data || {};
                    if (!data._metadata || data._metadata.outcomeCode !== 0) {
                        const message = data._metadata && data._metadata.message
                            ? data._metadata.message
                            : 'Unable to generate SPA PDF.';
                        this.$store.dispatch(SET_SNACK, { clr: 'error', msg: message });
                        return;
                    }

                    const token = data.records && data.records.token;
                    if (!token) {
                        this.$store.dispatch(SET_SNACK, { clr: 'error', msg: 'Unable to generate SPA PDF.' });
                        return;
                    }

                    const url = `${window.location.origin}/spa-form/${token}`;
                    window.open(url, '_blank');
                })
                .catch(() => {
                    this.$store.dispatch(SET_SNACK, { clr: 'error', msg: 'Unable to generate SPA PDF.' });
                })
                .finally(() => {
                    this.$set(this, 'spaFormPdfLoadingId', null);
                });
        },
        normalizeListingPrice(value) {
            if (value === null || value === undefined || value === '') {
                return 0;
            }
            if (typeof value === 'number') {
                return isNaN(value) ? 0 : value;
            }

            const normalized = String(value).replace(/[^0-9.]/g, '');
            const parsed = parseFloat(normalized);

            return isNaN(parsed) ? 0 : parsed;
        },
        formatListingPriceForReserve(...candidates) {
            for (const candidate of candidates) {
                const amount = this.normalizeListingPrice(candidate);
                if (amount > 0) {
                    return this.addTSBV(String(Math.round(amount)));
                }
            }

            return '';
        },
        buildReserveDialogItem(listItem, detail = {}) {
            const latestReserve = detail.latest_reserve || listItem.latest_reserve || null;
            const latestBook = detail.latest_book || listItem.latest_book || null;
            const maxSalePrice = this.formatListingPriceForReserve(
                listItem.reserve_sale_price,
                detail.max_sale_price,
                detail.max_price_temp,
                listItem.max_sale_price,
                detail.min_sale_price,
                listItem.min_sale_price
            );
            const reservationPrice = this.formatListingPriceForReserve(
                listItem.reservation_price,
                detail.reservation_price,
                latestBook ? latestBook.price : null,
                latestReserve ? latestReserve.price : null
            );

            return {
                ...listItem,
                ...detail,
                max_sale_price: maxSalePrice,
                min_sale_price: this.formatListingPriceForReserve(
                    detail.min_sale_price,
                    listItem.min_sale_price
                ),
                reservation_price: reservationPrice,
                payment_plans: listItem.payment_plans || detail.payment_plans || [],
                latest_reserve: latestReserve ? {
                    ...latestReserve,
                    price: reservationPrice || latestReserve.price,
                } : null,
                latest_book: latestBook ? {
                    ...latestBook,
                    price: reservationPrice || latestBook.price,
                } : null,
            };
        },
        closeResDialog() {
            this.resDialog = false;
            this.resItem = {};
        },
        closeRelDialog() {
            this.relDialog = false;
            this.resItem = {};
        },
        closeBookDialog() {
            this.bookDialog = false;
            this.resItem = {};
        },
        getBookButtonLabel(item) {
            const count = item && item.project && item.project.project_bank_details_count;

            return count > 0 ? 'Book' : 'EOI';
        },
        isListingEoi(item) {
            const count = item && item.project && Number(item.project.project_bank_details_count);

            return !count || count <= 0;
        },
        getListingBookingActionWord(item) {
            return this.isListingEoi(item) ? 'EOI' : 'Booked';
        },
        getBookedUserDisplayName(user) {
            if (!user) {
                return '';
            }

            const vendorName = user.vendor && user.vendor.name ? String(user.vendor.name).trim() : '';
            const userName = user.name ? String(user.name).trim() : '';

            if (vendorName && userName) {
                if (vendorName.toLowerCase() === userName.toLowerCase()) {
                    return vendorName;
                }

                return `${vendorName} (${userName})`;
            }

            return vendorName || userName;
        },
        getListingBookedStatusLine(item) {
            if (!item || !item.booked_user) {
                return '';
            }

            const action = this.getListingBookingActionWord(item);

            return `${action} By ${this.getBookedUserDisplayName(item.booked_user)}`;
        },
        getViewFormButtonLabel(item) {
            if (this.isListingEoi(item)) {
                return 'View EOI Form';
            }

            return 'View Booked Form';
        },
        getBookDialogTitle(item) {
            return this.isListingEoi(item) ? 'EOI Unit' : 'Book Unit';
        },
        getListingBookedStatusMessage(item) {
            return this.isListingEoi(item)
                ? 'This listing already has an EOI.'
                : 'This listing is already booked.';
        },
        developerPdfAssetsReady(item) {
            const userType = Number(this.$store.state.auth.user.type);

            if (userType === 1) {
                return true;
            }

            if (userType === 2) {
                return !!this.$store.state.auth.user.pdf_assets_ready;
            }

            if (item && Object.prototype.hasOwnProperty.call(item, 'developer_pdf_assets_ready')) {
                return !!item.developer_pdf_assets_ready;
            }

            return false;
        },
        isReservedByCurrentUser(item) {
            if (!item || item.booked_user) {
                return false;
            }

            const currentUserId = Number(this.$store.state.auth.user.id);
            const reservedBy = Number(item.reserved_by || (item.reserved_user && item.reserved_user.id));

            return !!item.reserved_user && reservedBy > 0 && reservedBy === currentUserId;
        },
        isListingAlreadyReserved(item) {
            if (!item) {
                return false;
            }

            const reservedBy = Number(item.reserved_by || (item.reserved_user && item.reserved_user.id));
            if (!reservedBy) {
                return false;
            }

            const reserverName = item.reserved_user && item.reserved_user.name
                ? item.reserved_user.name
                : null;
            const message = reserverName
                ? `This listing is already reserved by ${reserverName}.`
                : 'This listing is already reserved.';

            this.$store.dispatch(SET_SNACK, { clr: 'error', msg: message });

            return true;
        },
        saveItem(item) {
            if (this.$refs.form.validate()) {
                let method = CREATE_LISTINGS;
                let id = item.id;
                // Legacy owner_ids chips are not used; Owners tab sends managed_owners.
                if (Object.prototype.hasOwnProperty.call(item, 'owner_ids')) {
                    this.$delete(item, 'owner_ids');
                }
                if (!this.modType) {
                    this.$set(item, 'managed_owners', this.listingOwners.map((owner) => ({
                        contact_id: Number(owner.id),
                        is_current: !!owner.is_current
                    })));
                } else if (Object.prototype.hasOwnProperty.call(item, 'managed_owners')) {
                    this.$delete(item, 'managed_owners');
                }
                let data = {
                    data: item
                };
                if (!item.publishing_status_id) {
                    this.$set(item, "publishing_status_id", this.resolveDraftPublishingStatusId());
                }
                this.$set(item, "title", this.generateListingTitle(item));
                this.$set(item, "location_ref", this.locationRefModel);
                if (this.modType === 'project') {
                    this.$set(item, "location_ref", "project");
                    this.$set(item, "project_id", this.project.id);
                }
                if (this.modType === 'development') {
                    this.$set(item, "location_ref", "development");
                    this.$set(item, "project_id", this.project.id);
                }
                if (this.modType === 'contact') {
                    // Owners are attached separately; do not set owner_ids on listing save.
                    this.$set(item, "c_id", this.contact.id);
                    this.$set(item, "is_type_contact", 1);
                    this.$set(item, "listings_view_source", "contact_properties");
                    this.$set(item, "contact_properties_contact_id", this.contact.id);
                    this.$set(item, "activity_finalize", 0);
                }
                if (!this.modType) {
                    this.$set(item, "is_listing", 1);
                }
                const pendingFiles = this.$store.state.uploads.uploadedStateOtherFiles;
                const pendingLinks = this.$store.state.uploads.uploadedStateLinks;
                if (hasMeaningfulUploadedFiles(pendingFiles)) {
                    this.$set(item, "listing_files", pendingFiles);
                } else {
                    this.$delete(item, "listing_files");
                }
                if (hasMeaningfulUploadedLinks(pendingLinks)) {
                    this.$set(item, "listing_links", pendingLinks);
                } else {
                    this.$delete(item, "listing_links");
                }
                this.$set(item, "listing_fees", this.$store.state.listings.uploadedListingFees);
                this.$set(item, "listing_features", this.$store.state.listings.uploadedListingFeatures);
                this.$set(item, "latitude", this.$store.state.listings.latitude);
                this.$set(item, "longitude", this.$store.state.listings.longitude);
                // this.$set(item, "yearly_service_charges", this.$store.state.listings.yearlyServiceCharges.replace(/,(?=\d{3})/g, ''));
                // this.$set(item, "monthly_cooling_charges", this.$store.state.listings.monthlyCoolingCharges.replace(/,(?=\d{3})/g, ''));
                item.yearly_service_charges = item.yearly_service_charges ? item.yearly_service_charges.replace(/,(?=\d{3})/g, '') : ''
                item.monthly_cooling_charges = item.monthly_cooling_charges ? item.monthly_cooling_charges.replace(/,(?=\d{3})/g, '') : ''
                item.min_rent_per_annum = item.min_rent_per_annum ? item.min_rent_per_annum.replace(/,(?=\d{3})/g, '') : ''
                item.max_rent_per_annum = item.max_rent_per_annum ? item.max_rent_per_annum.replace(/,(?=\d{3})/g, '') : ''
                item.rent_agency_fee_tenant = item.rent_agency_fee_tenant ? item.rent_agency_fee_tenant.replace(/,(?=\d{3})/g, '') : ''
                item.rent_agency_fee_landlord = item.rent_agency_fee_landlord ? item.rent_agency_fee_landlord.replace(/,(?=\d{3})/g, '') : ''
                item.rent_security_fee = item.rent_security_fee ? item.rent_security_fee.replace(/,(?=\d{3})/g, '') : ''
                item.total_rent = item.total_rent ? item.total_rent.replace(/,(?=\d{3})/g, '') : ''
                item.min_sale_price = item.min_sale_price ? item.min_sale_price.replace(/,(?=\d{3})/g, '') : ''
                item.max_sale_price = item.max_sale_price ? item.max_sale_price.replace(/,(?=\d{3})/g, '') : ''
                item.sale_original_price = item.sale_original_price ? item.sale_original_price.replace(/,(?=\d{3})/g, '') : ''
                item.sale_paid_of_original_price = item.sale_paid_of_original_price ? item.sale_paid_of_original_price.replace(/,(?=\d{3})/g, '') : ''
                item.sale_discount = item.sale_discount ? item.sale_discount.replace(/,(?=\d{3})/g, '') : ''
                item.sale_premium = item.sale_premium ? item.sale_premium.replace(/,(?=\d{3})/g, '') : ''
                item.sale_agency_fee_buyer = item.sale_agency_fee_buyer ? item.sale_agency_fee_buyer.replace(/,(?=\d{3})/g, '') : ''
                item.sale_agency_fee_seller = item.sale_agency_fee_seller ? item.sale_agency_fee_seller.replace(/,(?=\d{3})/g, '') : ''
                item.sale_dld_fee = item.sale_dld_fee ? item.sale_dld_fee.replace(/,(?=\d{3})/g, '') : ''
                item.sale_transfer_fee_buyer = item.sale_transfer_fee_buyer ? item.sale_transfer_fee_buyer.replace(/,(?=\d{3})/g, '') : ''
                item.sale_transfer_fee_seller = item.sale_transfer_fee_seller ? item.sale_transfer_fee_seller.replace(/,(?=\d{3})/g, '') : ''
                item.sale_trustee_office_fee = item.sale_trustee_office_fee ? item.sale_trustee_office_fee.replace(/,(?=\d{3})/g, '') : ''
                item.sale_dev_noc_fee = item.sale_dev_noc_fee ? item.sale_dev_noc_fee.replace(/,(?=\d{3})/g, '') : ''
                item.sale_legal_fee = item.sale_legal_fee ? item.sale_legal_fee.replace(/,(?=\d{3})/g, '') : ''
                item.sale_payable_now = item.sale_payable_now ? item.sale_payable_now.replace(/,(?=\d{3})/g, '') : ''
                item.sale_payable_now_developer = item.sale_payable_now_developer ? item.sale_payable_now_developer.replace(/,(?=\d{3})/g, '') : ''
                item.tenancy_rent = item.tenancy_rent ? item.tenancy_rent.replace(/,(?=\d{3})/g, '') : ''
                this.$set(item, "built_up_area_unit", this.builtUpAreaUnit);
                this.$set(item, "plot_area_unit", this.plotAreaUnit);
                this.$set(item, "warehouse_office_space_unit", this.warehouseOfficeSpaceUnit);
                this.$set(item, "warehouse_open_yard_unit", this.warehouseOpenYardUnit);
                this.$set(item, "warehouse_storage_area_unit", this.warehouseStorageAreaUnit);
                // this.$set(item, "view_ids", this.$store.state.selections.selectedViewIds);
                // this.$set(item, "location_remark_ids", this.$store.state.selections.selectedLRIds);
                // this.$set(item, "amenity_ids", this.$store.state.selections.selectedAmenityIds);
                // this.$set(item, "road_location_ids", this.$store.state.selections.selectedRLIds);
                if (Number(this.$store.state.auth.user.type) === 1) {
                    this.$set(item, 'add_on_broker_portal', Number(item.add_on_broker_portal) === 1 ? 1 : 0);
                } else {
                    this.$set(item, 'add_on_broker_portal', 0);
                }
                if (id) {
                    method = UPDATE_LISTINGS;
                }
                this.$store.dispatch(CLEAR_LISTINGS_ERRORS);
                this.$store.dispatch(method, {'slug': id, data: data.data}).then(() => {
                    // if (method === 'update_listings') {
                    //     this.showUploadedFiles = false;
                    //     bus.$emit("moduleFilesDeletedByModal");
                    //     bus.$emit("listingFeesDeletedByModal");
                    //     bus.$emit("listingFeaturesDeletedByModal");
                    //     this.showEditDialog(item);
                    // } else {
                    //     this.dialog = false;
                    // }
                    this.loadData().then(response => {
                        this.items = response.items;
                        this.totalRecords = response.total;
                    });
                    if (this.modType !== 'contact') {
                        this.dialog = !this.dialog;
                    }
                    if (this.$route.query.hasOwnProperty('addModule')) {
                        window.close();
                    }
                })
            }
        },
        finalizePendingActivityLog() {
            const id = this.editedItem && this.editedItem.id;
            if (!id || this.modType !== 'contact' || !this.contact || !this.contact.id) {
                return Promise.resolve();
            }
            ApiService.setHeader();
            return ApiService.post("api/finalizelistingactivity/" + id, {
                listings_view_source: 'contact_properties',
                contact_properties_contact_id: this.contact.id,
                c_id: this.contact.id,
            });
        },
        openListingActivityLogs(item) {
            this.activityLogsListingId = item.id;
            const title = item.title ? String(item.title) : '';
            const ref = item.ref_number ? String(item.ref_number) : '';
            this.activityLogsTitle = title || (ref ? ('Listing ' + ref) : ('Listing #' + item.id));
            this.activityLogsDialog = true;
        },
        closeListingActivityLogs() {
            this.activityLogsDialog = false;
            this.$nextTick(() => {
                this.activityLogsListingId = null;
                this.activityLogsTitle = '';
            });
        },
        onActivityLogsDialogInput(open) {
            if (!open) {
                this.closeListingActivityLogs();
            }
        },
        mapOwnerHistoryToManagedOwners(history) {
            // Manage tab = open (current) owners only. Past history stays in View Owners popup.
            const rows = Array.isArray(history) ? history : [];
            const ranked = rows.slice().sort((a, b) => {
                const aOpen = a && !a.ended_at ? 1 : 0;
                const bOpen = b && !b.ended_at ? 1 : 0;
                if (aOpen !== bOpen) {
                    return bOpen - aOpen;
                }
                const ac = a && a.is_current ? 1 : 0;
                const bc = b && b.is_current ? 1 : 0;
                if (ac !== bc) {
                    return bc - ac;
                }
                const ad = a && a.date ? Date.parse(String(a.date)) : 0;
                const bd = b && b.date ? Date.parse(String(b.date)) : 0;
                if (ad !== bd) {
                    return (Number.isFinite(bd) ? bd : 0) - (Number.isFinite(ad) ? ad : 0);
                }
                return (Number(a && a.id) || 0) - (Number(b && b.id) || 0);
            });
            const seen = {};
            const out = [];
            ranked.forEach((row) => {
                const id = Number(row && row.id) || 0;
                if (!id || seen[id]) {
                    return;
                }
                // Skip ended-only history rows so Remove stays permanent in this tab.
                if (row.ended_at) {
                    return;
                }
                seen[id] = true;
                out.push({
                    id,
                    uid: row.uid || null,
                    full_name: String(row.full_name || '').replace(/\s+/g, ' ').trim(),
                    is_current: true,
                    date: row.date || null,
                    ended_at: null,
                    link_id: row.link_id || null
                });
            });
            return out;
        },
        openOwnersHistoryDialog(item) {
            if (!item || !item.id) {
                return;
            }
            const title = item.title ? String(item.title) : '';
            const uid = item.uid ? String(item.uid).toUpperCase() : '';
            this.ownersHistoryTitle = title || (uid ? ('Listing ' + uid) : ('Listing #' + item.id));
            this.ownersHistoryItems = [];
            this.ownersHistoryLoading = true;
            this.ownersHistoryDialog = true;
            const requestId = ++this.ownersHistoryRequestId;
            this.$store.dispatch(GET_LISTINGS_DETAILS, item.id).then((data) => {
                if (requestId !== this.ownersHistoryRequestId) {
                    return;
                }
                const records = data && data.records ? data.records : {};
                this.ownersHistoryItems = Array.isArray(records.owner_history)
                    ? records.owner_history
                    : [];
                this.ownersHistoryLoading = false;
            }).catch(() => {
                if (requestId !== this.ownersHistoryRequestId) {
                    return;
                }
                this.ownersHistoryItems = [];
                this.ownersHistoryLoading = false;
                this.$store.dispatch(SET_SNACK, {clr: 'error', msg: 'Owners could not be loaded.'});
            });
        },
        closeOwnersHistoryDialog() {
            this.ownersHistoryRequestId += 1;
            this.ownersHistoryDialog = false;
            this.ownersHistoryLoading = false;
            this.$nextTick(() => {
                this.ownersHistoryItems = [];
                this.ownersHistoryTitle = '';
            });
        },
        onOwnersHistoryDialogInput(open) {
            if (!open) {
                this.closeOwnersHistoryDialog();
            }
        },
        deleteItem(item) {
            let that = this;
            this.$store.dispatch(SET_CONFIRMATION, {
                title: "Are you sure?",
                msg: "You want to delete this listing?",
                clr: 'red',
                callback: function () {
                    let id = item.id;
                    this.$store.dispatch(DELETE_LISTINGS, {
                        'id': id
                    }).then(() => {
                        that.loadData().then(response => {
                            that.items = response.items;
                            that.totalRecords = response.total;
                        });
                    });
                }
            });
        },
        cSChange(evt) {
            // if (evt) {
            //     if (evt === 7) {
            //         this.editedItem.sale_dev_noc_fee = "500"
            //     } else {
            //         this.editedItem.sale_dev_noc_fee = "5,000"
            //     }
            // } else {
            //     this.editedItem.sale_dev_noc_fee = ""
            // }
        },
        normalizeCompletionStatusTitle(title) {
            return String(title || '').trim().toLowerCase();
        },
        resolveLocationCompletionStatusTitle(source) {
            if (!source) {
                return '';
            }
            if (source.completion_status && source.completion_status.title) {
                return String(source.completion_status.title).trim();
            }
            return '';
        },
        applyCompletionStatusFromLocation(source) {
            const title = this.resolveLocationCompletionStatusTitle(source);
            const applyMatch = () => {
                if (!title) {
                    this.$set(this.editedItem, 'completion_status_id', null);
                    return;
                }
                const needle = this.normalizeCompletionStatusTitle(title);
                const match = (this.completionStatusesFilter || []).find((status) =>
                    this.normalizeCompletionStatusTitle(status.title) === needle
                );
                this.$set(this.editedItem, 'completion_status_id', match ? match.id : null);
            };
            if ((this.completionStatusesFilter || []).length) {
                applyMatch();
                return;
            }
            this.$store.dispatch(COMPLETIONSTATUSES_SIMPLE_LIST, {type: 'Properties'}).then((data) => {
                this.completionStatusesFilter = (data.records && data.records.completionStatusesList) || [];
                applyMatch();
            });
        },
        getPurposes(loadNext = true) {
            this.$store.dispatch(PURPOSES_SIMPLE_LIST).then((data) => {
                this.purposesFilter = data.records.purposesList;
                if (loadNext) this.getPropertyTypes()
            });
        },
        getPropertyTypes(loadNext = true) {
            let that = this;
            this.$store.dispatch(DEVELOPMENTTYPES_SIMPLE_LIST, {type: 'all', is_property: 1}).then((data) => {
                data.records.developmentTypesList.forEach(function (v) {
                    if (v.parent_id) {
                        that.ptFilter.push(v)
                    }
                })
                if (loadNext) this.getCompletionStatuses()
            });
        },
        getCompletionStatuses(loadNext = true) {
            this.$store.dispatch(COMPLETIONSTATUSES_SIMPLE_LIST, {type: 'Properties'}).then((data) => {
                this.completionStatusesFilter = data.records.completionStatusesList;
                if (loadNext) this.getPublishingStatuses()
            });
        },
        getPublishingStatuses(loadNext = true) {
            this.$store.dispatch(PUBLISHINGSTATUSES_SIMPLE_LIST).then((data) => {
                this.publishingStatusesFilter = data.records.publishingStatusesList;
                if (this.dialog) {
                    this.applyDefaultDraftPublishingStatus();
                }
                if (loadNext) this.getSources()
            });
        },
        getSources(loadNext = true) {
            this.$store.dispatch(SOURCES_SIMPLE_LIST).then((data) => {
                this.sourcesFilter = data.records.sourcesList;
                if (loadNext) this.getViews()
            });
        },
        getViews(loadNext = true) {
            this.$store.dispatch(VIEWS_SIMPLE_LIST, {type: 'Properties'}).then((data) => {
                this.viewsFilter = data.records.viewsList;
                let that = this;
                this.viewsFilter.forEach(function (v) {
                    if (v.children.length > 0) {
                        v.children.forEach(function (vv) {
                            that.viewsIdsFilter.push(vv.id)
                        })
                    }
                })
                if (loadNext) this.getAmenities()
            });
        },
        getAmenities(loadNext = true) {
            this.$store.dispatch(AMENITIES_SIMPLE_LIST, {type: 'Properties'}).then((data) => {
                this.amenitiesFilter = data.records.amenitiesList;
                let that = this;
                this.amenitiesFilter.forEach(function (v) {
                    if (v.children.length > 0) {
                        v.children.forEach(function (vv) {
                            that.amenitiesIdsFilter.push(vv.id)
                        })
                    }
                })
                if (loadNext) this.getRoadLocations()
            });
        },
        getRoadLocations(loadNext = true) {
            this.$store.dispatch(ROADLOCATIONS_SIMPLE_LIST, {type: 'Properties'}).then((data) => {
                this.rlFilter = data.records.roadLocationsList;
                let that = this;
                this.rlFilter.forEach(function (v) {
                    if (v.children.length > 0) {
                        v.children.forEach(function (vv) {
                            that.rlIdsFilter.push(vv.id)
                        })
                    }
                })
                if (loadNext) this.getLocationRemarks()
            });
        },
        getLocationRemarks(loadNext = true) {
            this.$store.dispatch(LOCATIONREMARKS_SIMPLE_LIST, {type: 'Properties'}).then(data => {
                this.locationRemarksFilter = data.records.locationRemarksList;
                let that = this;
                this.locationRemarksFilter.forEach(function (v) {
                    if (v.children.length > 0) {
                        v.children.forEach(function (vv) {
                            that.locationRemarksIdsFilter.push(vv.id)
                        })
                    }
                })
                if (loadNext) this.getStaff()
            });
        },
        getStaff(loadNext = true) {
            this.$store.dispatch(STAFF_LIST).then((data) => {
                this.staffFilter = data.records.staffList;
                if (loadNext) this.getRentFrequencies()
            });
        },
        getRentFrequencies(loadNext = true) {
            this.$store.dispatch(FREQUENCIES_SIMPLE_LIST, {type: 'Full Term'}).then((data) => {
                this.rfFilter = data.records.frequenciesList;
                if (loadNext) this.getShortTermRentFrequencies()
            });
        },
        getShortTermRentFrequencies() {
            this.$store.dispatch(FREQUENCIES_SIMPLE_LIST, {type: 'Short Term'}).then((data) => {
                this.strfFilter = data.records.frequenciesList;
            });
        },
        getInternalUnitTypes(pId) {
            this.$store.dispatch(PROJECTUNITTYPES_SIMPLE_LIST, {project_id: pId, type: '0'}).then((data) => {
                this.iutFilter = data.records.projectUnitTypesList;
                this.getExternalUnitTypes(pId)
            });
        },
        getExternalUnitTypes(pId) {
            this.$store.dispatch(PROJECTUNITTYPES_SIMPLE_LIST, {project_id: pId, type: '1'}).then((data) => {
                this.eutFilter = data.records.projectUnitTypesList;
                this.getTypicalFloorPlans(pId)
            });
        },
        getTypicalFloorPlans(pId) {
            this.$store.dispatch(PROJECTTYPICALFLOORPLANS_SIMPLE_LIST, {project_id: pId}).then((data) => {
                this.tfpFilter = data.records.projectTypicalFloorPlansList;
            });
        },
        projectsFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isProjectsLoaded = true;
                    that.$store
                        .dispatch(PROJECTS_SIMPLE_LIST, {
                            q: query,
                            type: that.locationRef
                        })
                        .then(data => {
                            that.projectsFilter = (data && data.records && data.records.projectsList) || [];
                            that.isProjectsLoaded = false;
                        })
                        .catch(() => {
                            that.isProjectsLoaded = false;
                        });
                }
            }, 900);
        },
        mapListingLocationItem(item, locationRef) {
            const ref = locationRef || item.location_ref || 'development';
            const id = item.id;
            const title = item.title || item.commercial_title || '';
            const type = item.type !== undefined && item.type !== null ? Number(item.type) : null;
            let locationTypeLabel = 'Development';
            if (ref === 'project') {
                locationTypeLabel = 'Project';
            } else if (type === 0) {
                locationTypeLabel = 'Master Development';
            } else if (type === 1) {
                locationTypeLabel = 'Sub Development';
            }
            return {
                ...item,
                id,
                title,
                text: item.text || title,
                type,
                location_ref: ref,
                location_type_label: locationTypeLabel,
                uid: ref + '-' + id
            };
        },
        getDebouncedSearchQuery(e) {
            if (e == null) {
                return '';
            }
            if (typeof e === 'string') {
                return e;
            }
            if (e.target && e.target.value != null) {
                return String(e.target.value);
            }
            return '';
        },
        filterLocationsFilterKeyUp(e) {
            clearTimeout(this.apiTimeout);
            const that = this;
            const query = this.getDebouncedSearchQuery(e);
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isFilterLocationsLoaded = true;
                    const selectedUid = that.searchFormData.locationSearch;
                    const selected = (that.filterLocationsFilter || []).filter((l) => l.uid === selectedUid);
                    that.$store
                        .dispatch(DEVELOPMENTS_AND_PROJECTS_SIMPLE_LIST, {
                            type: 'all',
                            q: query,
                            countryId: that.$store.state.auth.user.country_id,
                            cityId: that.$store.state.auth.user.city_id
                        })
                        .then(data => {
                            const raw = (data && data.records && data.records.results) || [];
                            const results = raw.map((item) => that.mapListingLocationItem(item));
                            const byUid = {};
                            selected.forEach((l) => { byUid[l.uid] = l; });
                            results.forEach((l) => { byUid[l.uid] = l; });
                            that.filterLocationsFilter = Object.values(byUid);
                            that.isFilterLocationsLoaded = false;
                        })
                        .catch(() => {
                            that.isFilterLocationsLoaded = false;
                        });
                }
            }, 900);
        },
        onListingsFilterLocationChange(uid) {
            this.$delete(this.searchFormData, 'projectSearch');
            this.$delete(this.searchFormData, 'developmentSearch');
            if (!uid) {
                this.$delete(this.searchFormData, 'locationSearch');
                return;
            }
            this.$set(this.searchFormData, 'locationSearch', uid);
            const selected = (this.filterLocationsFilter || []).filter((l) => l.uid === uid);
            if (selected.length) {
                this.filterLocationsFilter = selected.concat(
                    (this.filterLocationsFilter || []).filter((l) => l.uid !== uid)
                );
            }
        },
        locationsFilterKeyUp(e) {
            clearTimeout(this.apiTimeout);
            const that = this;
            const query = this.getDebouncedSearchQuery(e);
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isLocationsLoaded = true;
                    const selectedUid = that.editedItem.location_uid;
                    const selected = (that.locationsFilter || []).filter((l) => l.uid === selectedUid);
                    that.$store
                        .dispatch(DEVELOPMENTS_AND_PROJECTS_SIMPLE_LIST, {
                            type: that.listingLocationSearchType,
                            q: query,
                            countryId: that.$store.state.auth.user.country_id,
                            cityId: that.$store.state.auth.user.city_id
                        })
                        .then(data => {
                            const raw = (data && data.records && data.records.results) || [];
                            const results = raw.map((item) => that.mapListingLocationItem(item));
                            const byUid = {};
                            // Keep selected only if it still matches current search mode.
                            selected.forEach((l) => {
                                if (that.isLocationAllowedForCurrentPropertyType(l)) {
                                    byUid[l.uid] = l;
                                }
                            });
                            results.forEach((l) => { byUid[l.uid] = l; });
                            that.locationsFilter = Object.values(byUid);
                            that.isLocationsLoaded = false;
                        })
                        .catch(() => {
                            that.isLocationsLoaded = false;
                        });
                }
            }, 900);
        },
        onListingLocationChange(uid) {
            this.listingLocationSearch = null;
            if (!uid) {
                this.editedItem.project_id = '';
                this.editedItem.location_uid = '';
                this.locationRefModel = '';
                this.clearProjectDerivedFields();
                return;
            }
            const loc = (this.locationsFilter || []).find((l) => l.uid === uid);
            if (!loc) return;
            this.$set(this.editedItem, 'location_uid', uid);
            this.locationRefModel = loc.location_ref;
            this.editedItem.project_id = loc.id;
            if (loc.location_ref === 'project') {
                this.applySelectedProject(loc.id);
            } else {
                this.clearProjectDerivedFields();
                this.$store.dispatch(DEVELOPMENTS_SIMPLE_BY_IDS_LIST, {ids: String(loc.id)}).then((data) => {
                    const development = (data.records.developmentsList || [])[0];
                    if (development) {
                        development.model = 'development';
                        development.title = development.commercial_title || development.title;
                        this.projectsChange(development);
                    }
                });
            }
        },
        applySelectedProject(projectId) {
            this.getInternalUnitTypes(projectId);
            this.loadProjectUnitNumbers(projectId);
            this.$store.dispatch(GET_PROJECTS_DETAILS, projectId).then((data) => {
                const project = data && data.records ? data.records : null;
                if (!project) return;
                project.model = 'project';
                this.projectsChange(project);
            });
        },
        loadProjectUnitNumbers(projectId) {
            if (!projectId) {
                this.unitNumberFilter = [];
                return;
            }
            this.isUnitNumberLoaded = true;
            this.$store
                .dispatch(GET_PROJECTUNITDETAILS_DETAILS_BY_UNIT_NUMBER, {
                    project_id: projectId,
                    unit_no: ''
                })
                .then((data) => {
                    this.unitNumberFilter = data.records.projectUnitDetailsList || [];
                    this.isUnitNumberLoaded = false;
                })
                .catch(() => {
                    this.unitNumberFilter = [];
                    this.isUnitNumberLoaded = false;
                });
        },
        clearProjectDerivedFields() {
            this.iutFilter = [];
            this.eutFilter = [];
            this.tfpFilter = [];
            this.unitNumberFilter = [];
            this.$set(this.editedItem, 'internal_unit_type_id', null);
            this.$set(this.editedItem, 'external_unit_type_id', null);
            this.$set(this.editedItem, 'typical_floor_plan_id', null);
            this.$set(this.editedItem, 'search_unit_no', null);
        },
        generateListingTitle(item) {
            const pt = this.selectedListingPropertyType
                || (item && item.property_type)
                || null;
            const ptTitle = pt ? String(pt.title || pt.full_title || '').trim() : '';
            const loc = (this.locationsFilter || []).find((l) => l.uid === (item && item.location_uid))
                || (this.locationsFilter || []).find((l) => Number(l.id) === Number(item && item.project_id));
            const locTitle = loc
                ? String(loc.title || loc.commercial_title || '')
                    .replace(/<[^>]*>/g, '')
                    .trim()
                : '';
            const unit = item && item.unit_no ? String(item.unit_no).trim() : '';
            const title = [ptTitle, locTitle, unit].filter(Boolean).join(' - ');
            return title.substring(0, 200) || 'Listing';
        },
        onListingPropertyTypeChange() {
            if (!this.showListingPlotArea) {
                this.$set(this.editedItem, 'plot_area', '');
                this.$set(this.editedItem, 'plot_area_width', '');
                this.$set(this.editedItem, 'plot_area_length', '');
            }
            if (this.isListingCommercialPropertyType) {
                this.$set(this.editedItem, 'no_of_bedrooms', null);
                this.$set(this.editedItem, 'no_of_bathrooms', null);
            }
            if (this.isListingPlotOrLandPropertyType) {
                this.clearProjectDerivedFields();
            }
            this.syncListingLocationWithPropertyType();
        },
        isLocationAllowedForCurrentPropertyType(loc) {
            if (!loc) return false;
            if (this.isListingPlotOrLandPropertyType) {
                return loc.location_ref === 'development';
            }
            return loc.location_ref === 'project';
        },
        syncListingLocationWithPropertyType() {
            const uid = this.editedItem && this.editedItem.location_uid;
            if (!uid) {
                this.locationsFilter = (this.locationsFilter || []).filter((l) =>
                    this.isLocationAllowedForCurrentPropertyType(l)
                );
                return;
            }
            const loc = (this.locationsFilter || []).find((l) => l.uid === uid);
            if (loc && this.isLocationAllowedForCurrentPropertyType(loc)) {
                this.locationsFilter = (this.locationsFilter || []).filter((l) =>
                    this.isLocationAllowedForCurrentPropertyType(l)
                );
                return;
            }
            this.editedItem.project_id = '';
            this.editedItem.location_uid = '';
            this.locationRefModel = '';
            this.locationsFilter = [];
            this.clearProjectDerivedFields();
        },
        projectsChange(project) {
            if (project) {
                this.editedItem.project_id = project.id;
                this.editedItem.no_of_bedrooms = '';
                this.editedItem.no_of_bathrooms = '';
                this.editedItem.built_up_area = '';
                this.editedItem.plot_area = '';
                this.builtUpAreaUnit = this.$store.state.auth.user.measurement_unit;
                this.plotAreaUnit = this.$store.state.auth.user.measurement_unit;
                this.locationRefModel = project.model || this.locationRefModel;
                if (project.developer) {
                    this.developersFilter = [];
                    this.editedItem.developer_id = project.developer_id;
                    this.developersFilter = [project.developer];
                } else {
                    this.developersFilter = [];
                    this.editedItem.developer_id = null;
                }

                // Autofill completion status by title (Properties vs Projects/Developments IDs differ).
                this.applyCompletionStatusFromLocation(project);

                // Project-only autofill (layouts / units already loaded in applySelectedProject).
                if (this.locationRefModel === 'project') {
                    this.editedItem.description = project.description || '';
                    this.editedItem.launch_date = project.launch_date || null;
                    this.editedItem.registration_date = project.registration_date || null;
                    this.editedItem.construction_started_date = project.construction_started_date || null;
                    this.editedItem.anticipated_completion_date = project.anticipated_completion_date || null;
                    this.editedItem.handover_date = project.handover_date || null;
                    this.editedItem.meta_title = project.meta_title || null;
                    this.editedItem.meta_keywords = project.meta_keywords || null;
                    this.editedItem.focus_keywords = project.focus_keywords || null;
                    this.editedItem.meta_description = project.meta_description || null;
                    this.editedItem.amenity_ids = project.amenity_ids || [];
                    this.editedItem.road_location_ids = project.road_location_ids || [];
                    this.editedItem.view_ids = project.view_ids || [];
                }

                this.$store.state.listings.latitude = project.latitude;
                this.$store.state.listings.longitude = project.longitude;
                this.editedItem.location = project.location;
            }
        },
        developersFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isDevelopersLoaded = true;
                    that.$store
                        .dispatch(CONTACTS_SIMPLE_LIST, {
                            role: 'Developers',
                            q: query
                        })
                        .then(data => {
                            const list = (data && data.records && data.records.contactsList) || [];
                            that.developersFilter = that.developersFilter.concat(list);
                            that.isDevelopersLoaded = false;
                        })
                        .catch(() => {
                            that.isDevelopersLoaded = false;
                        });
                }
            }, 900);
        },
        coolingProvidersFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isCoolingProvidersLoaded = true;
                    that.$store
                        .dispatch(CONTACTS_SIMPLE_LIST, {
                            role: 'Cooling Providers',
                            q: query
                        })
                        .then(data => {
                            const list = (data && data.records && data.records.contactsList) || [];
                            that.coolingProvidersFilter = that.coolingProvidersFilter.concat(list);
                            that.isCoolingProvidersLoaded = false;
                        })
                        .catch(() => {
                            that.isCoolingProvidersLoaded = false;
                        });
                }
            }, 900);
        },
        yscKeyUp(evt) {
            if (!evt.target.value) {
                this.$store.state.listings.yearlyServiceCharges = ''
            } else {
                let val = evt.target.value;
                val = val.replace(/[^0-9\.]/g, '');
                if (val != "") {
                    let valArr = val.split('.');
                    valArr[0] = (parseInt(valArr[0], 10)).toLocaleString();
                    val = valArr.join('.');
                }
                this.yscValue = val;

                if (
                    evt.target.value &&
                    this.editedItem.built_up_area &&
                    this.builtUpAreaUnit &&
                    this.yscMultiplyValue &&
                    this.yscMultiplyValue === "0"
                ) {
                    this.$store.state.listings.yearlyServiceCharges = this.unitCalculator(this.builtUpAreaUnit, this.yscValue.replace(/,(?=\d{3})/g, ''), this.editedItem.built_up_area)
                    this.$store.state.listings.yearlyServiceCharges = this.addTSBV(this.$store.state.listings.yearlyServiceCharges)
                }

                if (
                    evt.target.value &&
                    this.editedItem.plot_area &&
                    this.plotAreaUnit &&
                    this.yscMultiplyValue &&
                    this.yscMultiplyValue === "1"
                ) {
                    this.$store.state.listings.yearlyServiceCharges = this.unitCalculator(this.plotAreaUnit, this.yscValue.replace(/,(?=\d{3})/g, ''), this.editedItem.plot_area)
                    this.$store.state.listings.yearlyServiceCharges = this.addTSBV(this.$store.state.listings.yearlyServiceCharges)
                }
            }
        },
        yscMultiply(v) {
            if (!v) {
                this.$store.state.listings.yearlyServiceCharges = ''
            }
            if (v === '0') {
                if (
                    this.yscValue &&
                    this.editedItem.built_up_area &&
                    this.builtUpAreaUnit
                ) {
                    this.$store.state.listings.yearlyServiceCharges = this.unitCalculator(this.builtUpAreaUnit, this.yscValue.replace(/,(?=\d{3})/g, ''), this.editedItem.built_up_area);
                    this.$store.state.listings.yearlyServiceCharges = this.addTSBV(this.$store.state.listings.yearlyServiceCharges)
                }
            }
            if (v === '1') {
                if (
                    this.yscValue &&
                    this.editedItem.plot_area &&
                    this.plotAreaUnit
                ) {
                    this.$store.state.listings.yearlyServiceCharges = this.unitCalculator(this.plotAreaUnit, this.yscValue.replace(/,(?=\d{3})/g, ''), this.editedItem.plot_area);
                    this.$store.state.listings.yearlyServiceCharges = this.addTSBV(this.$store.state.listings.yearlyServiceCharges)
                }
            }
        },
        mccKeyUp(evt) {
            if (!evt.target.value) {
                this.$store.state.listings.monthlyCoolingCharges = ''
            } else {
                let val = evt.target.value;
                val = val.replace(/[^0-9\.]/g, '');
                if (val != "") {
                    let valArr = val.split('.');
                    valArr[0] = (parseInt(valArr[0], 10)).toLocaleString();
                    val = valArr.join('.');
                }
                this.mccValue = val;
                if (
                    evt.target.value &&
                    this.editedItem.built_up_area &&
                    this.builtUpAreaUnit &&
                    this.mccMultiplyValue &&
                    this.mccMultiplyValue === "0"
                ) {
                    this.$store.state.listings.monthlyCoolingCharges = this.unitCalculator(this.builtUpAreaUnit, this.mccValue.replace(/,(?=\d{3})/g, ''), this.editedItem.built_up_area)
                    this.$store.state.listings.monthlyCoolingCharges = this.addTSBV(this.$store.state.listings.monthlyCoolingCharges)
                }

                if (
                    evt.target.value &&
                    this.editedItem.plot_area &&
                    this.plotAreaUnit &&
                    this.mccMultiplyValue &&
                    this.mccMultiplyValue === "1"
                ) {
                    this.$store.state.listings.monthlyCoolingCharges = this.unitCalculator(this.plotAreaUnit, this.mccValue.replace(/,(?=\d{3})/g, ''), this.editedItem.plot_area)
                    this.$store.state.listings.monthlyCoolingCharges = this.addTSBV(this.$store.state.listings.monthlyCoolingCharges)
                }
            }
        },
        mccMultiply(v) {
            if (!v) {
                this.$store.state.listings.monthlyCoolingCharges = ''
            }
            if (v === '0') {
                if (
                    this.mccValue &&
                    this.editedItem.built_up_area &&
                    this.builtUpAreaUnit
                ) {
                    this.$store.state.listings.monthlyCoolingCharges = this.unitCalculator(this.builtUpAreaUnit, this.mccValue.replace(/,(?=\d{3})/g, ''), this.editedItem.built_up_area);
                    this.$store.state.listings.monthlyCoolingCharges = this.addTSBV(this.$store.state.listings.monthlyCoolingCharges)
                }
            }
            if (v === '1') {
                if (
                    this.mccValue &&
                    this.editedItem.plot_area &&
                    this.plotAreaUnit
                ) {
                    this.$store.state.listings.monthlyCoolingCharges = this.unitCalculator(this.plotAreaUnit, this.mccValue.replace(/,(?=\d{3})/g, ''), this.editedItem.plot_area);
                    this.$store.state.listings.monthlyCoolingCharges = this.addTSBV(this.$store.state.listings.monthlyCoolingCharges)
                }
            }
        },
        clearChargesValues() {
            this.yscValue = '';
            this.mccValue = '';
            this.$store.state.listings.monthlyCoolingCharges = ''
            this.$store.state.listings.yearlyServiceCharges = ''
        },
        ownersFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isOwnersLoaded = true;
                    that.$store
                        .dispatch(CONTACTS_SIMPLE_LIST, {
                            role: 'Real Estate Owners',
                            q: query
                        })
                        .then(data => {
                            const list = (data && data.records && data.records.contactsList) || [];
                            that.ownersFilter = that.ownersFilter.concat(list);
                            that.isOwnersLoaded = false;
                        })
                        .catch(() => {
                            that.isOwnersLoaded = false;
                        });
                }
            }, 900);
        },
        onKeyLocationsSelectionChange() {
            this.keyLocationsSearch = null;
        },
        onOwnersSelectionChange() {
            this.ownersSearch = null;
        },
        onCoolingProvidersSelectionChange() {
            this.coolingProvidersSearch = null;
        },
        onDevelopersSelectionChange() {
            this.developersSearch = null;
        },
        kLFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isKLLoaded = true;
                    that.$store
                        .dispatch(CONTACTS_SIMPLE_LIST, {
                            role: 'Key Locations',
                            q: query
                        })
                        .then(data => {
                            const list = (data && data.records && data.records.contactsList) || [];
                            that.kLFilter = that.kLFilter.concat(list);
                            that.isKLLoaded = false;
                        })
                        .catch(() => {
                            that.isKLLoaded = false;
                        });
                }
            }, 900);
        },
        tenantsFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isTenantsLoaded = true;
                    that.$store
                        .dispatch(CONTACTS_SIMPLE_LIST, {
                            role: 'Tenant',
                            q: query
                        })
                        .then(data => {
                            const list = (data && data.records && data.records.contactsList) || [];
                            that.tenantsFilter = that.tenantsFilter.concat(list);
                            that.isTenantsLoaded = false;
                        })
                        .catch(() => {
                            that.isTenantsLoaded = false;
                        });
                }
            }, 900);
        },
        iutChange(iut) {
            this.editedItem.internal_unit_type_id = iut.id;
            if (!this.editedItem.uni_no) {
                this.editedItem.built_up_area = iut.max_built_up_area;
                this.builtUpAreaUnit = iut.built_up_area_unit ? iut.built_up_area_unit : 'Square Feet';
                this.editedItem.built_up_area_length = iut.max_built_up_area_length;
                this.editedItem.built_up_area_width = iut.max_built_up_area_width;

                this.editedItem.plot_area = iut.max_plot_area;
                this.plotAreaUnit = iut.plot_area_unit ? iut.plot_area_unit : 'Square Feet';
                this.editedItem.plot_area_length = iut.max_plot_area_length;
                this.editedItem.plot_area_width = iut.max_plot_area_width;
            }
            this.editedItem.no_of_bathrooms = iut.no_of_bathrooms;
            this.editedItem.no_of_bedrooms = iut.no_of_bedrooms;
            this.editedItem.listing_features = iut.project_unit_type_features;
        },
        unitNumberKeyUp(e) {
            const query = this.getDebouncedSearchQuery(e);
            if (query) {
                this.isUnitNumberLoaded = true;
                this.$store
                    .dispatch(GET_PROJECTUNITDETAILS_DETAILS_BY_UNIT_NUMBER, {
                        project_id: this.editedItem.project_id,
                        unit_no: query
                    })
                    .then(data => {
                        this.unitNumberFilter = (data && data.records && data.records.projectUnitDetailsList) || [];
                        this.isUnitNumberLoaded = false;
                    })
                    .catch(() => {
                        this.isUnitNumberLoaded = false;
                    });
            }
        },
        clearUnitNumberAutofill() {
            this.$set(this.editedItem, 'search_unit_no', null);
            this.$set(this.editedItem, 'unit_no', '');
            this.ownersFilter = [];
            this.$set(this.editedItem, 'owner_ids', []);
            this.$set(this.editedItem, 'location_remark_ids', []);
            this.coolingProvidersFilter = [];
            this.$set(this.editedItem, 'cooling_provider_ids', []);
            this.$store.state.listings.yearlyServiceCharges = '';
            this.$store.state.listings.monthlyCoolingCharges = '';
            this.yscValue = '';
            this.mccValue = '';
            this.$set(this.editedItem, 'built_up_area', '');
            this.$set(this.editedItem, 'built_up_area_length', '');
            this.$set(this.editedItem, 'built_up_area_width', '');
            this.$set(this.editedItem, 'plot_area', '');
            this.$set(this.editedItem, 'plot_area_length', '');
            this.$set(this.editedItem, 'plot_area_width', '');
            this.$set(this.editedItem, 'floor', '');
            this.$set(this.editedItem, 'year_built', '');
            this.$set(this.editedItem, 'street_name_no', '');
            this.$set(this.editedItem, 'parking_no', '');
            this.$set(this.editedItem, 'no_of_parking', '');
            this.$set(this.editedItem, 'land_no', '');
            this.$set(this.editedItem, 'official_residence_no', '');
            this.$set(this.editedItem, 'electricity_meter_no', '');
            this.$set(this.editedItem, 'gas_meter_no', '');
            this.$set(this.editedItem, 'municipality_number', '');
            this.$set(this.editedItem, 'no_of_bedrooms', null);
            this.$set(this.editedItem, 'no_of_bathrooms', null);
        },
        unitNumberChange(data) {
            if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
                this.clearUnitNumberAutofill();
                return;
            }
            this.editedItem.unit_no = data.unit_no;
            this.ownersFilter = data.owners || [];
            this.editedItem.location_remark_ids = data.location_remark_ids || [];
            this.editedItem.owner_ids = data.owner_ids || [];
            this.coolingProvidersFilter = data.cooling_providers || [];
            this.editedItem.cooling_provider_ids = data.cooling_provider_ids || [];
            this.$store.state.listings.yearlyServiceCharges = data.yearly_service_charges || '';
            this.$store.state.listings.monthlyCoolingCharges = data.monthly_cooling_charges || '';
            if (data.built_up_area !== null && data.built_up_area !== undefined && data.built_up_area !== '') {
                this.editedItem.built_up_area = this.unitConverter(
                    data.built_up_area_unit,
                    data.built_up_area,
                    this.$store.state.auth.user.measurement_unit
                );
            }
            this.editedItem.built_up_area_length = data.built_up_area_length;
            this.editedItem.built_up_area_width = data.built_up_area_width;

            if (data.plot_area !== null && data.plot_area !== undefined && data.plot_area !== '') {
                this.editedItem.plot_area = this.unitConverter(
                    data.plot_area_unit,
                    data.plot_area,
                    this.$store.state.auth.user.measurement_unit
                );
            }
            this.editedItem.plot_area_length = data.plot_area_length;
            this.editedItem.plot_area_width = data.plot_area_width;

            this.editedItem.floor = data.floor;
            this.editedItem.year_built = data.year_built;
            this.editedItem.street_name_no = data.street_name_no;
            this.editedItem.parking_no = data.parking_no;
            this.editedItem.no_of_parking = data.no_of_parking;
            this.editedItem.land_no = data.land_no;
            this.editedItem.official_residence_no = data.official_residence_no;
            this.editedItem.electricity_meter_no = data.electricity_meter_no;
            this.editedItem.gas_meter_no = data.gas_meter_no;
            this.editedItem.municipality_number = data.municipality_number;
            if (data.no_of_bedrooms !== undefined && data.no_of_bedrooms !== null && data.no_of_bedrooms !== '') {
                this.editedItem.no_of_bedrooms = data.no_of_bedrooms;
            }
            if (data.no_of_bathrooms !== undefined && data.no_of_bathrooms !== null && data.no_of_bathrooms !== '') {
                this.editedItem.no_of_bathrooms = data.no_of_bathrooms;
            }
        },
        openMatchLeadsDialog(item) {
            if (!item || !item.id) return;
            this.matchLeadsDialog = true;
            this.matchLeadsLoading = true;
            this.matchLeadsItems = [];
            this.matchLeadsListingId = item.id;
            this.matchLeadsListingTitle = item.title || item.uid || ('#' + item.id);
            this.$store.dispatch(GET_LEADS_BY_LISTING, item.id).then((data) => {
                this.matchLeadsItems = (data && data.records && data.records.leadsList)
                    ? data.records.leadsList
                    : [];
                this.matchLeadsLoading = false;
            }).catch(() => {
                this.matchLeadsItems = [];
                this.matchLeadsLoading = false;
            });
        },
        closeMatchLeadsDialog() {
            this.matchLeadsDialog = false;
            this.matchLeadsLoading = false;
            this.matchLeadsItems = [];
            this.matchLeadsListingId = null;
            this.matchLeadsListingTitle = '';
        },
        formatMatchLeadBudget(lead) {
            if (!lead) return '-';
            const min = lead.min_price ? Number(lead.min_price) : null;
            const max = lead.max_price ? Number(lead.max_price) : null;
            const fmt = (n) => Number(n).toLocaleString();
            if (min && max) return fmt(min) + ' - ' + fmt(max);
            if (min) return 'From ' + fmt(min);
            if (max) return 'Up to ' + fmt(max);
            return '-';
        },
        updateRBStatus(id, column, msg){
            let that = this;
            this.$store.dispatch(SET_CONFIRMATION, {
                title: "Are you sure?", msg: "You want to " + msg + " this unit?", clr: 'red', callback: function () {
                    that.updateStatus(1, id, column)
                }
            });
        },
        updateStatus(status, id, column) {
            this.$store.dispatch(CLEAR_LISTINGS_ERRORS);
            let data = {
                status: status,
                column: column
            };
            this.$store.dispatch(UPDATE_LISTINGS_STATUS, {'slug': id, data: data}).then(()=>{
                this.loadData().then(response => {
                    this.items = response.items;
                    this.totalRecords = response.total;
                });
            })
        },
        getPercentageByAmount(e, amt, index) {
            if (e.target.value) {
                let value = parseFloat(e.target.value.replace(/,(?=\d{3})/g, ''));
                let amount = parseFloat(amt.replace(/,(?=\d{3})/g, ''));
                this.editedItem[index] = ((value / amount) * 100).toFixed(2)
            } else {
                this.editedItem[index] = ''
            }
        },
        getAmountByPercentage(e, amt, index) {
            if (e.target.value) {
                let value = parseFloat(e.target.value.replace(/,(?=\d{3})/g, ''));
                let amount = parseFloat(amt.replace(/,(?=\d{3})/g, ''));
                this.editedItem[index] = this.addTSBV(((value / 100) * amount).toFixed())
            } else {
                this.editedItem[index] = ''
            }
        },
        getAmountByPercentageWe(e, amt, index) {
            if (e) {
                let value = parseFloat(e.replace(/,(?=\d{3})/g, ''));
                let amount = parseFloat(amt.replace(/,(?=\d{3})/g, ''));
                this.editedItem[index] = this.addTSBV(((value / 100) * amount).toFixed())
            } else {
                this.editedItem[index] = ''
            }
        },
        getPercentageByAmountWe(e, amt, index) {
            if (e) {
                let value = parseFloat(e.replace(/,(?=\d{3})/g, ''));
                let amount = parseFloat(amt.replace(/,(?=\d{3})/g, ''));
                this.editedItem[index] = ((value / amount) * 100).toFixed(2)
            } else {
                this.editedItem[index] = ''
            }
        },
        projectsChangeForDuplication(evt) {
            clearTimeout(this.apiTimeout)
            this.dupItem = ''
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (evt) {
                    that.isListingsLoaded = true;
                    that.$store
                        .dispatch(LISTINGS_SIMPLE_LIST, {
                            type: that.locationRef,
                            refId: evt
                        })
                        .then(data => {
                            that.listingsFilter = data.records.listingsList;
                            that.isListingsLoaded = false;
                        });
                }
            }, 900);
        },
        propertyTypeChangeForDuplication(obj) {
            this.duplicatedItem.p_id = '';
            if (obj) {
                this.duplicatedItem.p_type_id = obj.id;
                this.masterPropertyType = this.checkPropertyType(obj)
                if (this.masterPropertyType === '') {
                    this.locationRef = 'project'
                } else {
                    this.locationRef = 'development'
                }
            }
        },
        listingsFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isListingsLoaded = true;
                    that.$store
                        .dispatch(LISTINGS_SIMPLE_LIST, {
                            q: query
                        })
                        .then(data => {
                            that.listingsFilter = (data && data.records && data.records.listingsList) || [];
                            that.isListingsLoaded = false;
                        })
                        .catch(() => {
                            that.isListingsLoaded = false;
                        });
                }
            }, 900);
        },
        duplicateListing(id) {
            let that = this;
            this.$store.dispatch(SET_CONFIRMATION, {
                title: "Are you sure?", msg: "You want to duplicate this listing?", clr: 'red', callback: function () {
                    this.$store.dispatch(DUPLICATE_LISTING, {
                        'listing_id': id
                    }).then((res) => {
                        that.dupDialog = false
                        that.showEditDialog('edit', res.records)
                        that.loadData().then(response => {
                            that.items = response.items;
                            that.totalRecords = response.total;
                        });
                    });
                }
            });
        },
        developmentsFilterKeyUp(e) {
            clearTimeout(this.apiTimeout)
            const query = this.getDebouncedSearchQuery(e);
            let that = this
            this.apiTimeout = setTimeout(function () {
                if (query.length >= 3) {
                    that.isDevelopmentsLoaded = true;
                    that.$store
                        .dispatch(DEVELOPMENTS_SIMPLE_LIST, {
                            q: query
                        })
                        .then(data => {
                            that.developmentsFilter = (data && data.records && data.records.developmentsList) || [];
                            that.isDevelopmentsLoaded = false;
                        })
                        .catch(() => {
                            that.isDevelopmentsLoaded = false;
                        });
                }
            }, 900);
        },
        updateSharedListings(type, item) {
            if (type === 'edit') {
                this.showEditDialog('edit', item)
            } else {
                this.showEditDialog('detail', item)
            }
        },
        showShareDialog() {
            if (!this.staffFilter.length) {
                this.getStaff(false);
            }
            this.shareDialog = true;
            this.listingSharingIds = this.$store.state.auth.user.listing_sharing_ids
        },
        shareListings() {
            this.$store.dispatch(CLEAR_LISTINGS_ERRORS);
            this.$store.dispatch(SHARE_LISTING, {'user_ids': this.listingSharingIds}).then(() => {
                this.$store.dispatch(VERIFY_AUTH)
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                this.shareDialog = false
            })
        },
        showTree(id, type) {
            this.pagination.page = 1
            const loadPromises = []

            if (id !== 0) {
                this.$delete(this.searchFormData, 'projectSearch');
                this.$delete(this.searchFormData, 'developmentSearch');
                const uid = type === 'project' ? ('project-' + id) : ('development-' + id);
                this.$set(this.searchFormData, 'locationSearch', uid);
                const titleFromTree = this.findTreeLocationTitle(this.treeItems, id, type);
                this.filterLocationsFilter = [this.mapListingLocationItem({
                    id: id,
                    title: titleFromTree || (type === 'project' ? ('Project #' + id) : ('Development #' + id)),
                    text: titleFromTree || (type === 'project' ? ('Project #' + id) : ('Development #' + id)),
                    location_ref: type === 'project' ? 'project' : 'development',
                    type: type === 'project' ? null : (type === 'development' ? 1 : 0)
                }, type === 'project' ? 'project' : 'development')];
                loadPromises.push(
                    this.loadData().then(response => {
                        this.items = response.items;
                        this.totalRecords = response.total;
                    })
                );
            }
            if (type === 'development' || type === 'all') {
                let searchFormDataQuery = Object.keys(this.searchFormData).map((key) => {
                    const value = this.searchFormData[key];
                    if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
                        return null;
                    }
                    return encodeURIComponent(key) + '=' + encodeURIComponent(value)
                }).filter(Boolean).join('&');
                loadPromises.push(
                    this.$store.dispatch(DEVELOPMENTS_WITH_COUNT, {
                        type: 'listings',
                        'id': id,
                        'get': type,
                        query: searchFormDataQuery
                    }).then((data) => {
                        this.treeItems = data.records.developmentsList
                    })
                );
            }

            if (id !== 0 && loadPromises.length > 0) {
                Promise.all(loadPromises).then(() => {
                    this.locationSearchQuery = ''
                });
            }
        },
        findTreeLocationTitle(nodes, id, type) {
            const list = Array.isArray(nodes) ? nodes : [];
            for (let i = 0; i < list.length; i++) {
                const node = list[i];
                if (!node) continue;
                if (type === 'project' && Number(node.project_id || node.id) === Number(id) && (node.model === 'project' || node.location_ref === 'project')) {
                    return node.title || node.commercial_title || '';
                }
                if (type !== 'project' && Number(node.id) === Number(id)) {
                    return node.commercial_title || node.title || '';
                }
                const childTitle = this.findTreeLocationTitle(node.children || node.projects || [], id, type);
                if (childTitle) return childTitle;
            }
            return '';
        },
        emailListing(item) {
            this.$router.push({
                name: 'contacts',
                query: {share: 'listing', rid: item.id}
            })
        },
        orgPKeyUp(e) {
            this.editedItem.sale_original_price = this.addTS(e)
            if (e.target.value) {
                this.updatePremiumDiscountFromPrices()
            }
        },
        popKeyUp(e) {
            this.editedItem.sale_paid_of_original_price = this.addTS(e);
            this.getPercentageByAmount(e, this.editedItem.sale_original_price, 'paid_of_original_price_percentage')
            if (e.target.value) {
                this.updatePayableFromPop()
            }
        },
        popPercentageKeyUp(e) {
            this.getAmountByPercentage(e, this.editedItem.sale_original_price, 'sale_paid_of_original_price')
            if (e.target.value) {
                this.updatePayableFromPop()
            }
        },
        parsePrice(value) {
            if (value === null || value === undefined || value === '') {
                return null
            }
            const num = parseFloat(String(value).replace(/,/g, ''))
            return isNaN(num) ? null : num
        },
        updatePremiumDiscountFromPrices() {
            const op = this.parsePrice(this.editedItem.sale_original_price)
            const msp = this.parsePrice(this.editedItem.max_sale_price)
            if (op === null || msp === null) {
                return
            }
            if (msp > op) {
                this.editedItem.sale_premium = this.addTSBV(msp - op)
                this.editedItem.sale_discount = ''
            } else if (op > msp) {
                this.editedItem.sale_discount = this.addTSBV(op - msp)
                this.editedItem.sale_premium = ''
            } else {
                this.editedItem.sale_discount = ''
                this.editedItem.sale_premium = ''
            }
            this.updatePayableFromPop()
        },
        updatePayableFromPop() {
            const sop = this.parsePrice(this.editedItem.sale_original_price)
            const pop = this.parsePrice(this.editedItem.sale_paid_of_original_price)
            if (sop === null || pop === null) {
                return
            }
            this.editedItem.sale_payable_now_developer = this.addTSBV(sop - pop)
            const comparison = this.salePriceComparison
            if (comparison === 'premium') {
                const premium = this.parsePrice(this.editedItem.sale_premium) || 0
                this.editedItem.sale_payable_now = this.addTSBV(pop + premium)
            } else if (comparison === 'discount') {
                const discount = this.parsePrice(this.editedItem.sale_discount) || 0
                this.editedItem.sale_payable_now = this.addTSBV(pop - discount)
            } else {
                this.editedItem.sale_payable_now = this.addTSBV(pop)
            }
        },
        discountKeyUp(e) {
            this.editedItem.sale_discount = this.addTS(e)
            if (e.target.value) {
                this.updatePayableFromPop()
            }
        },
        premiumKeyUp(e) {
            this.editedItem.sale_premium = this.addTS(e)
            if (e.target.value) {
                this.updatePayableFromPop()
            }
        },
        mspSalePriceKeyUp(e) {
            this.editedItem.max_sale_price = this.addTS(e)
            this.getAmountByPercentageWe('2', this.editedItem.max_sale_price, 'sale_agency_fee_buyer')
            this.editedItem.sale_agency_fee_buyer_percentage = '2'
            this.getAmountByPercentageWe('2', this.editedItem.max_sale_price, 'sale_agency_fee_seller')
            this.editedItem.sale_agency_fee_seller_percentage = '2'
            this.getAmountByPercentageWe('4', this.editedItem.max_sale_price, 'sale_transfer_fee_buyer')
            this.editedItem.sale_transfer_fee_buyer_percentage = '4'
            this.checkTrusteeFee(e)
            if (e.target.value) {
                this.updatePremiumDiscountFromPrices()
            }
        },
        mspKeyUp(e) {
            clearTimeout(this.apiTimeout)
            let that = this
            this.apiTimeout = setTimeout(function () {
                let val = e.target.value.replace(/,(?=\d{3})/g, '')
                that.getAmountByPercentageWe("2", that.editedItem.max_sale_price, 'sale_agency_fee_buyer')
                that.editedItem.sale_agency_fee_buyer_percentage = "2"
                that.editedItem.max_sale_price = that.addTS(e)
            }, 900);
        },
        checkTrusteeFee(e) {
            if (e.target.value) {
                if (parseInt(e.target.value.replace(/,(?=\d{3})/g, '')) > 500000) this.editedItem.sale_trustee_office_fee = "4,400"
                if (parseInt(e.target.value.replace(/,(?=\d{3})/g, '')) < 500000) this.editedItem.sale_trustee_office_fee = "2,200"
            }
        },
        setUnitNo(e) {
            let domain = '';
            if (this.$store.state.auth.user.team_id === 1) {
                domain = 'dubricks.com'
            }
            if (this.$store.state.auth.user.team_id === 2) {
                domain = 'afsrealestate.com'
            }
            if (e) {
                this.showUnitNo = 1
                let url = 'https://' + domain + '/listing-price-report?ref=' + this.editedItem.id + '&tkn=6ad4f1r5gg4b1g5h4r552d6g1'
                this.generateReport(url)
            } else {
                this.showUnitNo = 0
                let url = 'https://' + domain + '/listing-price-report?ref=' + this.editedItem.id + '&tkn=15s4d1e51fs48ert4g1g5gh4f'
                // this.reportLink = 'http://localhost:8080/listing-price-report?ref=' + this.editedItem.id + '&tkn=15s4d1e51fs48ert4g1g5gh4f'
                this.generateReport(url)
            }
        },
        generateReport(link) {
            if (link) {
                this.$store.dispatch(SAVE_REPORT, {
                    url: link,
                    title: 'Listing Price Report',
                    description: '',
                })
                    .then(data => {
                        this.reportLink = 'https://links.dubricks.com/' + data.records.u_id
                        // this.reportLink = 'http://urls.de/' + data.records.u_id
                        this.sumDialog = true
                    });
            }
        },
        copyLink() {
            let linkToCopy = document.querySelector('#report-link')
            linkToCopy.setAttribute('type', 'text')
            linkToCopy.select()
            try {
                let successful = document.execCommand('copy');
                if (successful) {
                    this.$store.dispatch(SET_SNACK, {clr: 'success', msg: 'Report Link Copied Successfully'});
                } else {
                    this.$store.dispatch(SET_SNACK, {clr: 'error', msg: 'Report Link Not Copied'});
                }
            } catch (err) {
                this.$store.dispatch(SET_SNACK, {clr: 'error', msg: 'Oops, Unable To Copy'});
            }
            linkToCopy.setAttribute('type', 'hidden')
            window.getSelection().removeAllRanges()
        },
        resDClose(){
            this.closeResDialog();
            this.loadData().then(response => {
                this.items = response.items;
                this.totalRecords = response.total;
            });
        },
        relDClose(){
            this.closeRelDialog();
            this.loadData().then(response => {
                this.items = response.items;
                this.totalRecords = response.total;
            });
        },
        bookDClose(){
            this.closeBookDialog();
            this.loadData().then(response => {
                this.items = response.items;
                this.totalRecords = response.total;
            });
        }
    },
    computed: {
        selectedListingPropertyType() {
            const id = this.editedItem && this.editedItem.property_type_id;
            if (!id) return this.editedItem && this.editedItem.property_type ? this.editedItem.property_type : null;
            return (this.ptFilter || []).find((p) => Number(p.id) === Number(id))
                || (this.editedItem && this.editedItem.property_type)
                || null;
        },
        showListingPlotArea() {
            const type = this.selectedListingPropertyType;
            if (!type) return false;
            const title = String(type.title || type.full_title || '').toLowerCase();
            return plotPropertyTypeKeywords.some((word) => title.includes(word));
        },
        isListingPlotOrLandPropertyType() {
            const type = this.selectedListingPropertyType;
            if (!type) return false;
            const title = String(type.title || type.full_title || '').toLowerCase();
            return plotOrLandPropertyTypeKeywords.some((word) => title.includes(word));
        },
        listingLocationSearchType() {
            return this.isListingPlotOrLandPropertyType ? 'development' : 'project';
        },
        showListingProjectLayouts() {
            return !this.isListingPlotOrLandPropertyType && this.locationRefModel === 'project';
        },
        isListingCommercialPropertyType() {
            const type = this.selectedListingPropertyType;
            if (!type) return false;
            if (Number(type.parent_id) === 5) return true;
            const parentTitle = type.parent ? String(type.parent.title || '').toLowerCase() : '';
            return parentTitle.includes('commercial');
        },
        parentPropertyType() {
            return this.isListingCommercialPropertyType ? 'commercial' : '';
        },
        isOfferListingsMode() {
            return this.offerListings === true
                || this.offerListings === 'true'
                || this.offerListings === 1
                || this.offerListings === '1';
        },
        isOfferPageFullySelected() {
            if (!this.isOfferListingsMode || !this.items || !this.items.length) {
                return false;
            }
            const selected = new Set((this.offerListingsSelection || []).map(id => Number(id)));
            return this.items.every(item => selected.has(Number(item.id)));
        },
        isOfferPagePartiallySelected() {
            if (!this.isOfferListingsMode || !this.items || !this.items.length) {
                return false;
            }
            const selected = new Set((this.offerListingsSelection || []).map(id => Number(id)));
            const selectedOnPage = this.items.filter(item => selected.has(Number(item.id))).length;
            return selectedOnPage > 0 && selectedOnPage < this.items.length;
        },
        showReservationActions() {
            if (!this.modType) {
                return true;
            }

            if (this.modType === 'project') {
                const userType = Number(this.$store.state.auth.user.type);

                if (userType === 2 || userType === 3 || userType === 4) {
                    return true;
                }

                // Agency sub-user (type 5): only once the project's NOC is approved.
                if (userType === 5) {
                    return Number(this.project && this.project.is_noc_approved) === 1;
                }
            }

            return false;
        },
        filteredTreeItems() {
            const query = (this.locationSearchQuery || '').trim().toLowerCase();
            if (!query) {
                return this.treeItems;
            }
            return this.treeItems.filter((item) =>
                (item.title || '').toLowerCase().includes(query)
            );
        },
        params() {
            return {
                ...this.pagination,
                query: this.searchQuery
            };
        },
        ...mapState({
            errors: state => state.listings.errors
        }),
        pageCount() {
            // return this.totalRecords / this.pagination.rowsPerPage
            return this.params.itemsPerPage <= this.totalRecords ? Math.ceil(this.totalRecords / this.params.itemsPerPage) : 0
        },
        formattedViewsIds() {
            const formatted = [];
            this.viewsFilter.forEach((group, groupIndex) => {
                formatted.push({
                    header: group.title,
                    // header: group.title + ' (' + group.children.length + ')',
                    disabled: true
                });
                group.children.forEach((child, childIndex) => {
                    formatted.push({
                        id: child.id,
                        text: child.title,
                        value: `${groupIndex}_${childIndex}`,
                        originalTitle: child.title
                    });
                });
                if (groupIndex < this.viewsFilter.length - 1) {
                    formatted.push({
                        divider: true
                    });
                }
            });
            return formatted;
        },
        formattedAmenitiesIds() {
            const formatted = [];
            this.amenitiesFilter.forEach((group, groupIndex) => {
                formatted.push({
                    header: group.title,
                    // header: group.title + ' (' + group.children.length + ')',
                    disabled: true
                });
                group.children.forEach((child, childIndex) => {
                    formatted.push({
                        id: child.id,
                        text: child.title,
                        value: `${groupIndex}_${childIndex}`,
                        originalTitle: child.title
                    });
                });
                if (groupIndex < this.amenitiesFilter.length - 1) {
                    formatted.push({
                        divider: true
                    });
                }
            });
            return formatted;
        },
        formattedRLIds() {
            const formatted = [];
            this.rlFilter.forEach((group, groupIndex) => {
                formatted.push({
                    header: group.title,
                    // header: group.title + ' (' + group.children.length + ')',
                    disabled: true
                });
                group.children.forEach((child, childIndex) => {
                    formatted.push({
                        id: child.id,
                        text: child.title,
                        value: `${groupIndex}_${childIndex}`,
                        originalTitle: child.title
                    });
                });
                if (groupIndex < this.rlFilter.length - 1) {
                    formatted.push({
                        divider: true
                    });
                }
            });
            return formatted;
        },
        formattedLRIds() {
            const formatted = [];
            this.locationRemarksFilter.forEach((group, groupIndex) => {
                formatted.push({
                    header: group.title,
                    // header: group.title + ' (' + group.children.length + ')',
                    disabled: true
                });
                group.children.forEach((child, childIndex) => {
                    formatted.push({
                        id: child.id,
                        text: child.title,
                        value: `${groupIndex}_${childIndex}`,
                        originalTitle: child.title
                    });
                });
                if (groupIndex < this.locationRemarksFilter.length - 1) {
                    formatted.push({
                        divider: true
                    });
                }
            });
            return formatted;
        },
        salePriceComparison() {
            const op = this.parsePrice(this.editedItem.sale_original_price)
            const msp = this.parsePrice(this.editedItem.max_sale_price)
            if (op === null || msp === null) {
                return null
            }
            if (msp > op) {
                return 'premium'
            }
            if (op > msp) {
                return 'discount'
            }
            return 'equal'
        },
        showSaleDiscount() {
            return this.salePriceComparison === 'discount'
        },
        showSalePremium() {
            return this.salePriceComparison === 'premium'
        },
    }
};
export default listingsScript